import React, { useState, useEffect, useRef } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { Link } from "react-router-dom";
import { DatePicker } from "antd";
import Select from "react-select";
import {
  Calendar,
  ArrowLeft,
  HelpCircle,
  Hash,
  CreditCard,
  Link2,
  Tag,
  FileText,
  Truck,
  MessageSquare,
  User,
  Home,
  Phone,
  Box,
  Plus,
  Minus,
  Shuffle,
  Repeat,
  Percent,
  Database,
  Trash2,
  RotateCcw,
  Printer,
  Check,
  UserCheck,
  Settings,
} from "feather-icons-react/build/IconComponents";
import {
  getTaxList,
  getUnitList,
  getCustomersList,
  getDiscountList,
  getWareHouseList,
} from "../../../services/MasterApiServices";
import { getProductList } from "../../../services/MasterApiServices";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelector } from "react-redux";
import { InvSales } from "../../../core/json/invSales";
import { InvSalesDetail } from "../../../core/json/invSalesDetail";
import { useDispatch } from "react-redux";
import {
  fetchUnit,
  fetchProduct,
  fetchTax,
  fetchCategory,
  fetchCustomer,
  fetchSettings,
} from "../../../redux/userSetting";
import {
  addEditSales,
  getSalesByTransType,
} from "../../../services/SalesApiServices";
import { fetchBranchSettings } from "../../../redux/settingbyBranch";
import { fetchUserByBranch } from "../../../redux/userServices";
import { FinancialYear } from "../../../core/json/FinancialYear";

import { ProductClass } from "../../../core/json/Product";
import { DiscountClass } from "../../../core/json/Discount";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";
import { TaxClass } from "../../../core/json/TaxClass";
import toast from "react-hot-toast";
import CustomerModal from "../../master/modal/CustomerModal";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "../../../style/fonts/Amiri";
import "../../../style/css/sales-invoice-modal.css";
import html2pdf from "html2pdf.js";

import "jspdf-autotable";
import QRCode from "qrcode";
import { Buffer } from "buffer";
import arabic from "arabic-persian-reshaper";
import {getPrintSettingsByBranch} from '../../../services/AdminApiServices';
const ar = (text) => arabic(text);

const SalesInvoiceModal = ({
  mode,
  data,
  handleClose,
  handleRefresh,
  // modalOpen,
}) => {
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    watch,
    control,
    setFocus,
    formState: { errors },
  } = useForm({
    defaultValues: {
      deliveryDate: dayjs().format("YYYY-MM-DD"),
      invdate: dayjs().format("YYYY-MM-DD"),
      paymentType: 0,
      referencetype: 0,
      salesMode: 0,
      addition: 0,
      change: 0,
      customerContactno: "",
      customerName: "",
      refNo: "0",
      subtraction: 0,
      round: 0,
    },
    mode: "onBlur",
  });

  
  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });
  const handleAddRow = () => {
    append({
      batch: "0",
      code: "0",
      discountAmount: "0.0",
      discountPercentage: "0.0",
      expiry: dayjs().format("YYYY-MM-DD"),
      foc: "0.0",
      gross: "0.0",
      // hsnCode: 0,
      mrp: "0.0",
      netTotal: "0.0",
      price: "0.0",
      quantity: "0",
      taxAmount: "0.0",
      taxPercentage: "0.0",
      notes: "",
      unit: "",
      product: null,
    });
  };

  // Batch / Exp Date / MRP / FOC are optional columns, chosen from the settings
  // popup in the Invoice Items header. Hidden with CSS so the inputs stay
  // mounted and keep feeding the form, the print builder and the payload.
  const OPTIONAL_COLS = [
    { key: "batch", label: "Batch" },
    { key: "expiry", label: "Exp Date" },
    { key: "mrp", label: "MRP" },
    { key: "foc", label: "FOC" },
  ];
  const COL_PREF_KEY = "salesInvoice.optionalColumns";
  const PRINT_PREF_KEY = "salesInvoice.printSettings";

  // Preferences survive the modal closing and the next visit to the screen.
  // localStorage is the store until the backend exposes a per-user settings
  // endpoint - swap readPref/writePref for that call and nothing else changes.
  const readPref = (key, fallback) => {
    try {
      const raw = window.localStorage.getItem(key);
      return raw ? { ...fallback, ...JSON.parse(raw) } : fallback;
    } catch {
      return fallback;
    }
  };
  const writePref = (key, value) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      /* storage unavailable - the choice just will not persist */
    }
  };

  const [optionalCols, setOptionalCols] = useState(() =>
    readPref(COL_PREF_KEY, {
      batch: false,
      expiry: false,
      mrp: false,
      foc: false,
    })
  );
  const colClass = (key) => (optionalCols[key] ? "" : "si-col-off");

  // Toggling a chip writes the preference straight away, so whatever is on
  // when you leave is still on the next time the screen opens.
  const toggleCol = (key) =>
    setOptionalCols((prev) => {
      const next = { ...prev, [key]: !prev[key] };
      writePref(COL_PREF_KEY, next);
      return next;
    });

  // Print preferences - default format and the printer to name on the output.
  // NOTE: `printSettings` is already taken by the branch print config fetched
  // from the API, so these user preferences are `printPrefs`.
  const [printPrefs, setPrintPrefs] = useState(() =>
    readPref(PRINT_PREF_KEY, {
      format: "A4",
      printerName: "",
      useSystemDefault: true,
    })
  );
  const [printPrefsOpen, setPrintPrefsOpen] = useState(false);
  const [draftPrint, setDraftPrint] = useState(printPrefs);
  const openPrintPrefs = () => {
    setDraftPrint(printPrefs);
    setPrintPrefsOpen(true);
  };
  const applyPrintPrefs = () => {
    setPrintPrefs(draftPrint);
    writePref(PRINT_PREF_KEY, draftPrint);
    setPrintPrefsOpen(false);
  };

  // SAVE & PRINT sets this before submitting, so the success path knows to
  // print with the saved default format once the invoice is actually stored.
  const [printOnSave, setPrintOnSave] = useState(false);

  // Per-line notes. The row index being edited, or null when the popup is shut.
  const [notesRow, setNotesRow] = useState(null);
  const [draftNote, setDraftNote] = useState("");
  const openNotes = (index) => {
    setDraftNote(getValues(`items[${index}].notes`) || "");
    setNotesRow(index);
  };
  const applyNotes = () => {
    setValue(`items[${notesRow}].notes`, draftNote);
    setNotesRow(null);
  };


  // An untouched row - no product, no quantity, no price.
  const isBlankRow = (row) =>
    !row?.product && !(Number(row?.quantity) > 0) && !(Number(row?.price) > 0);

  // The trailing blank row is only there to start the next entry: it is exempt
  // from validation and dropped before submit and before printing. A lone blank
  // row is not a placeholder - an invoice needs at least one real line.
  const isPlaceholderRow = (index) => {
    const rows = getValues("items") || [];
    return (
      rows.length > 1 && index === rows.length - 1 && isBlankRow(rows[index])
    );
  };

  // A blank row appears on its own once the last one has a product and a
  // quantity - so there is nothing to click to keep entering items.
  // NOTE: react-hook-form mutates its value store in place, so `watch("items")`
  // hands back the same array reference on every render. Depending on that
  // array directly would run this effect once and never again - the dependency
  // has to be a primitive built from the values we actually care about.
  const watchedItems = watch("items");
  const lastRow = watchedItems?.[watchedItems.length - 1];
  const lastRowKey = [
    watchedItems?.length ?? 0,
    lastRow?.product ?? "",
    lastRow?.quantity ?? "",
    lastRow?.price ?? "",
  ].join("|");

  useEffect(() => {
    const rows = getValues("items") || [];
    if (!rows.length) return;
    const last = rows[rows.length - 1];
    if (last?.product && Number(last?.quantity) > 0) handleAddRow();
  }, [lastRowKey]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUnit());
    dispatch(fetchProduct(branch));
    dispatch(fetchTax());
    dispatch(fetchSettings(branch));
    const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
    const currfmt = match ? match[0]?.length - 1 : 0;
    setDecimalPoints(currfmt);
    dispatch(fetchCustomer(branch));
    dispatch(fetchUserByBranch(branch));
  }, []);

  const { customerList } = useSelector((state) => state.usersetting);
  
  const [discountList, setdiscountList] = useState([]);

  const [taxData, setTaxData] = useState([]);
  const [printSettings, setPrintSettings] = useState(null);

  const [unitData, setunitData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [salesData, setsalesData] = useState([]);
  const [discountData, setdiscountData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [isRowAdded, setIsRowAdded] = useState(false);
  const [decimalpoints, setDecimalPoints] = useState(2);
  const [mindate, setmindate] = useState();
  // Get user from redux
  const { userId } = useSelector((state) => state.userauth);
  // Get branch from redux
  const { branch } = useSelector((state) => state.branchlist);

  const { productList, unitList, taxList, settingList } = useSelector(
    (state) => state.usersetting
  );
  const { branchsettings } = useSelector((state) => state.settings);
  const { UserListByBranch } = useSelector((state) => state.userservice);

  // Salesman is picked from the branch's users rather than typed free-hand.
  const salesmanOptions = (UserListByBranch || []).map((u) => ({
    label: u?.name,
    value: u?.guid,
  }));

  // Every picker renders its menu in a body-level portal. Previously the menus
  // used position:relative, which put them in the document flow - opening one
  // inside a row pushed the rest of that row out of line, and inside the
  // scrolling table body an absolute menu would simply have been clipped.
  const menuPortalTarget =
    typeof document !== "undefined" ? document.body : null;
  const siSelectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 11000 }),
    menu: (base) => ({ ...base, zIndex: 11000 }),
  };
  const { companyInfolist } = useSelector((state) => state.companyInfo);

  // Natural width of every column, so the table's min-width tracks the columns
  // actually on screen. Every column has a width in the stylesheet, so above
  // this figure the browser scales them all proportionally - switch optional
  // columns on and each one gives up a little room, switch them off and each
  // gets it back. Nothing is left to absorb the surplus on its own.
  const OPTIONAL_COL_WIDTH = { batch: 64, expiry: 92, mrp: 78, foc: 56 };
  const TAX_COL_WIDTH = 130; // Tax % + Tax Amount, hidden by branch setting
  const BASE_TABLE_WIDTH = 1058;
  const tableMinWidth =
    Object.keys(OPTIONAL_COL_WIDTH).reduce(
      (total, key) => total + (optionalCols[key] ? OPTIONAL_COL_WIDTH[key] : 0),
      BASE_TABLE_WIDTH
    ) - (branchsettings?.disableTaxInSale == false ? 0 : TAX_COL_WIDTH);
   
  // const companyList = companyInfolist.map((company) => ({
  //   name: company.name,
  //   address1: company.address1,
  //   address2: company.address2,
  //   address3: company.address3,
  //   phone: company.phone
  // }));
useEffect(() => {
  const fetchPrintSettings = async () => {
    try {
      const response = await getPrintSettingsByBranch(branch?.guid);
      setPrintSettings(response);
    } catch (error) {
      console.error("Failed to fetch print settings", error);
    }
  };

  if (branch?.guid) {
    fetchPrintSettings();
  }
}, [branch]);


  const paymentType = [
    { value: 0, label: "Cash" },
    { value: 1, label: "Credit" },
    { value: 2, label: "UPI" },
    { value: 3, label: "Card" },
  ];
  //   like reference type in purchase//transtype
  const referencetype = [
    { value: 0, label: "DIRECT" },
    { value: 1, label: "DN" },
    { value: 2, label: "ORDER" },
  ];

  const salesMode = [
    { value: 0, label: "NORMAL SERIES" },
    { value: 1, label: "QUOT SERIES" },
  ];
  useEffect(() => {}, [getValues, errors]);
  // const purchaseTransType = [
  //   { value: 0, label: "Sales Quotation" },
  //   { value: 1, label: "Delievery Note" },
  //   { value: 2, label: "Sales Invoice" },
  //   { value: 3, label: "Sales Return" },
  // ];

  const [warehouses, setWarehouses] = useState([]);
  
useEffect(() => {
  const fetchWarehouses = async () => {
    try {
      const response = await getWareHouseList();

      if (Array.isArray(response)) {
        // Filter warehouses by current branch
        const filtered = response.filter(
          (wh) => wh.branchID === branch?.guid
        );
        setWarehouses(filtered);
      } else {
        setWarehouses([]);
      }
    } catch (err) {
      console.error("Failed to fetch warehouses:", err);
    }
  };
  if (branch?.guid) {
    fetchWarehouses();
  }
}, [branch]);
  
const formattedWarehouses = Array.isArray(warehouses)
  ? warehouses.map((warehouse) => ({
      label: warehouse.name || "Unnamed Warehouse",
      value: warehouse,
    }))
  : [];

// Helper function to get selected warehouse option
const getSelectedWarehouseOption = (warehouse) => {
  if (!warehouse) return null;
  return (
    formattedWarehouses.find((wh) => wh.value.guid === warehouse.guid) || {
      label: warehouse.name || "Select Warehouse",
      value: warehouse,
    }
  );
};
// Helper to get default warehouse from branch settings
const getDefaultWarehouse = () => {
  if (!branchsettings?.defaultWareHouseID || !warehouses?.length) return null;
  const wh = warehouses.find((w) => w.guid === branchsettings.defaultWareHouseID);
  return wh ? getSelectedWarehouseOption(wh) : null;
};


  //Calculations ---------------
  const safeNumber = (value, defaultValue = 0) => {
    // Check for null, undefined, or empty string and use the default value
    if (value === null || value === undefined || value === "") {
      return defaultValue;
    }

    // Convert to number
    const num = Number(value);

    // Return the number or the default value if num is NaN
    return isNaN(num) ? defaultValue : num;
  };
  const rowUseForm = getValues("row") || [];

  let totalGross = 0;
  let totalDiscount = 0;
  let totalTax = 0;
  let totalNet = 0;
  let changevalue = 0;

  fields.forEach((field, index) => {
    const quantity = watch(`items[${index}].quantity`, 0);
    const price = watch(`items[${index}].price`, 0);
    const discount = watch(`items[${index}].discountPercentage`, 0);
    const taxGUID = watch(`items[${index}].taxPercentage`, 0);
    const tax = taxData.find((t)=>t.guid==taxGUID)?.value || 0;
    const grossTl = price * quantity || 0;
    const discountAmt = (grossTl * discount) / 100 || 0;
    const amountBeforeTax = grossTl - discountAmt || 0;
    const taxAmount = (amountBeforeTax * tax) / 100 || 0;
    const netTotal = amountBeforeTax + taxAmount || 0;

    setValue(`items[${index}].gross`, grossTl?.toFixed(decimalpoints));
    setValue(
      `items[${index}].discountAmount`,
      discountAmt?.toFixed(decimalpoints)
    );
    setValue(`items[${index}].taxAmount`, taxAmount?.toFixed(decimalpoints));
    setValue(`items[${index}].netTotal`, netTotal?.toFixed(decimalpoints));

    // Add to totalGross
    totalGross += grossTl;
    totalDiscount += discountAmt;
    totalTax += taxAmount;
    totalNet += netTotal;
  });
  //Final calculations on addition ,discount and round
  const addition = Number(watch(`addition`, 0));
  const subtraction = Number(watch(`subtraction`, 0));
  const round = Number(watch(`round`, 0));

  totalNet += safeNumber(addition);
  totalNet -= safeNumber(subtraction);
  totalNet -= safeNumber(round);
  totalDiscount = totalDiscount + safeNumber(subtraction);
  const paidvalue = Number(watch(`paid`), 0);
  if (paidvalue !== 0) {
    // Change = Paid - Net Total. Signed on purpose: a short payment has to read
    // as negative rather than as change owed back, so no Math.abs here.
    changevalue = safeNumber(paidvalue) - totalNet;
    setValue("change", changevalue?.toFixed(decimalpoints));
  } else {
    setValue("change", 0);
  }
  //end-------------
  function handleRemove(index) {
    if (fields.length > 1) {
      remove(index);
    } else {
      toast.error("At least one product entry is required");
    }
  }
  const handleDiscountList = async () => {
    try {
      const response = await getDiscountList();

      const formattedDiscount = response?.map((discount) => ({
        label: discount.percentage,
        value: discount.percentage,
        guid: discount.guid,
      }));
      setdiscountData(formattedDiscount);
      setdiscountList(response);
    } catch (error) {
      console.error(
        "Error fetching discount",
        error?.response?.data?.Message || "Unexpected error occured"
      );
    }
  };
  const handleUnitList = async () => {
    try {
      const response = await getUnitList();
      const formattedUnit = response?.map((unit) => ({
        label: unit.name,
        value: unit.guid,
      }));
      setunitData(formattedUnit);
    } catch (error) {
      console.error(
        "Error fetching",
        error?.response?.data?.Message || "Unexpected error occured"
      );
    }
  };


  

  const handleTaxList = async () => {
    try {
      const response = await getTaxList();

      const formattedTax = response?.map((tax) => ({
        label: tax.percentage,
        value: tax.percentage,
        guid: tax.guid,
      }));
      setTaxData(formattedTax);
    } catch (error) {
      console.error(
        "Error fetching tax",
        error?.response?.data?.Message || "Unexpected error occured"
      );
    }
  };

  const handleEachProductfetch = async (selectedOption, index) => {
    setValue(`items[${index}].product`, selectedOption.value);

    try {
      const productData = await getSingleProduct(selectedOption.value);

      setValue(
        `items[${index}].code`,
        `${productData?.barcode || productData?.code || ""}`
      );
      // setValue(`items[${index}].hsnCode`, productData?.hsnCode || 0);
      setValue(`items[${index}].unit`, productData?.unit || 0);
      setValue(`items[${index}].taxPercentage`, productData?.taxID || 0);
      setValue(`items[${index}].price`, productData?.retailRate || 0);

      // Picking an item means one of it unless the operator says otherwise, so
      // seed the quantity and drop the cursor straight into it - ready to type
      // over for any other number, or to scan the next barcode.
      const currentQty = Number(getValues(`items[${index}].quantity`));
      if (!currentQty) setValue(`items[${index}].quantity`, 1);
      setTimeout(() => {
        try {
          setFocus(`items[${index}].quantity`);
        } catch {
          /* row unmounted before the product resolved */
        }
      }, 0);
    } catch (error) {
      console.error(
        "Error fetching product by GUID:",
        error?.response?.data?.Message || "Unexpected error occured"
      );
    }
  };

  // Barcode entry / scanner input. A scanner types the digits then sends Enter,
  // so the same handler serves both a scan and a typed-in code.
  const handleBarcodeEntry = (rawValue, index) => {
    const scanned = `${rawValue ?? ""}`.trim();
    if (!scanned) return;

    const match = productList?.find(
      (p) =>
        `${p?.barcode ?? ""}`.trim() === scanned ||
        `${p?.code ?? ""}`.trim() === scanned
    );

    if (!match) {
      // put the row back to whatever product it already held
      const current = productList?.find(
        (p) => p.guid === getValues(`items[${index}].product`)
      );
      setValue(
        `items[${index}].code`,
        `${current?.barcode || current?.code || ""}`
      );
      toast.error(`No item found for barcode ${scanned}`);
      return;
    }

    // load it exactly the way picking from the name dropdown does
    handleEachProductfetch({ value: match.guid }, index);
  };

  // lets the item picker be searched by name, barcode or item code
  const productFilterOption = (option, rawInput) => {
    const input = `${rawInput ?? ""}`.trim().toLowerCase();
    if (!input) return true;
    const { label, barcode, code } = option.data || {};
    return (
      `${label ?? ""}`.toLowerCase().includes(input) ||
      `${barcode ?? ""}`.toLowerCase().includes(input) ||
      `${code ?? ""}`.toLowerCase().includes(input)
    );
  };

  async function getSingleProduct(guid) {
    try {
      const filteredData = productList?.filter(
        (product) => product.guid === guid
      );
      return filteredData[0];
    } catch (error) {
      console.error(
        "Error fetching products",
        error?.response?.data?.Message || "Unexpected error occured"
      );
    }
  }

  const handleCustomerList = async () => {
    try {
      const formattedCustomers = customerList?.map((customer) => ({
        label: customer.name,
        value: customer.guid,
      }));
      setCustomerData(formattedCustomers);
    } catch (error) {
      console.error(
        "Error fetching customers",
        error?.response?.data?.Message || "Unexpected error occured"
      );
    }
  };

  const handlesalesData = async () => {
    try {
      const response = await getSalesByTransType(branch, 2);
      setsalesData(response.data);
    } catch (error) {
      console.error("Failed to fetch sales invoices", error);
    }
  };
  const handlecustomerDetailFetch = async (selectedOption) => {
    try {
      const customerData = customerList?.find(
        (e) => e.guid == selectedOption.value
      );

      setValue("customerContactno", customerData?.mobile || 0);
      setValue("customerName", customerData?.name || "");
    } catch (error) {
      console.error("Error fetching product by GUID:", error);
    }
  };

  // Fetch sales invoices data
  const handleEntryNo = async () => {
    try {
      const response = await getSalesByTransType(branch, 2);
      const salesData = response.data;

      // Group entry numbers by prefix
      const entryGroups = salesData.reduce((groups, data) => {
        const entrynumber = data.entrynumber;
        // Extract the prefix (non-numeric characters)
        const prefix = entrynumber.match(/^[A-Za-z]+/)[0];
        // Extract the numeric part and convert it to an integer
        const entryNum = parseInt(entrynumber.replace(/\D/g, ""), 10);

        if (!groups[prefix]) {
          groups[prefix] = [];
        }
        groups[prefix].push(entryNum);

        return groups;
      }, {});

      // Get the desired prefix (e.g., "SQ")
      const prefix = "SI";
      const maxEntryNumber =
        entryGroups[prefix]?.length > 0 ? Math.max(...entryGroups[prefix]) : 0;

      // Increment the counter for the prefix
      const counter = maxEntryNumber + 1;

      // Set the new entry number with the updated counter
      setValue(`entrynumber`, `${prefix}${counter}`);
    } catch (error) {
      console.error(
        "Failed to fetch sales invoices",
        error?.response?.data?.Message || "Unexpected error occured"
      );
    }
  };

  // function resetmodal() {
  //   if (mode === "edit" && data) {
  //     setValue("terms", data.terms);
  //     setValue("entrynumber", data.entrynumber);
  //     setValue("salesMode", data.salesMode || 0);
  //     setValue("salesTransType", data.salesTransType || 2);
  //     setValue("paid", data.paid || 0);
  //     setValue("change", Number(data.change) || 0);
  //     setValue("refNo", data.refNo || 0);
  //     setValue("dispatch", data.dispatch || "");
  //     setValue("dispatchTrough", data.dispatchTrough || "");
  //     setValue("addition", data.additionalAmt || 0);
  //     setValue("subtraction", data.discAmt || 0);
  //     setValue("round", data.roundOff || 0);
  //     setValue("grossTotal", data.grossTotal || 0);
  //     setValue("discountTotal", data.discountTotal || 0);
  //     setValue("taxTotal", data.taxTotal || 0);
  //     setValue("netAmt", data.netAmt || 0);
  //     setValue("paymentType", data.salesPaymentType || 0);
  //     setValue("referencetype", data.reftype || 0);
  //     setValue("customer", data.customer.guid);
  //     setValue("customerContactno", data.customerContactno || "0");
  //     setValue("customerName", data.customerName || "");
  //     setValue("invdate", dayjs(data.invdate) || dayjs());
  //     setValue("deliveryDate", dayjs(data.deliveryDate) || dayjs());

  //     setValue(
  //       "items",
  //       data?.invSalesDetails?.map((detail, i) => {
  //         return {
  //           product: detail?.product?.guid,
  //           code: detail?.product?.code,
  //           // hsnCode: detail?.product?.hsnCode || 0,
  //           batch: detail.batch,
  //           expiry: dayjs(detail.expiryDate),
  //           unit: detail.unit?.guid,
  //           quantity: detail.quantity,
  //           price: detail.price,
  //           mrp: detail.mrp,
  //           foc: detail.foc,
  //           discountPercentage: detail.discPercentage,
  //           discountAmount: detail.discAmt,
  //           taxPercentage: detail.taxPercentage,
  //           gross: detail.gross,
  //           taxAmount: detail.taxamnt,
  //           netTotal: detail.netAmt,
  //         };
  //       })
  //     );
  //   }
  // }

  async function resetmodal() {
  if (mode === "edit" && data) {
    setValue("terms", data.terms);
    setValue("entrynumber", data.entrynumber);
    setValue("salesMode", data.salesMode || 0);
    setValue("salesTransType", data.salesTransType || 2);
    setValue("paid", data.paid || 0);
    setValue("change", Number(data.change) || 0);
    setValue("refNo", data.refNo || 0);
    setValue("dispatch", data.dispatch || "");
    setValue("dispatchTrough", data.dispatchTrough || "");
    setValue("addition", data.additionalAmt || 0);
    setValue("subtraction", data.discAmt || 0);
    setValue("round", data.roundOff || 0);
    setValue("grossTotal", data.grossTotal || 0);
    setValue("discountTotal", data.discountTotal || 0);
    setValue("taxTotal", data.taxTotal || 0);
    setValue("netAmt", data.netTotal || 0);
    setValue("paymentType", data.salesPaymentType || 0);
    setValue("referencetype", data.reftype || 0);
    setValue("customer", data.customer.guid);
    setValue("customerContactno", data.customerContactno || "0");
    setValue("customerName", data.customerName || "");
    setValue("invdate", dayjs(data.invdate) || dayjs());
    setValue("deliveryDate", dayjs(data.deliveryDate) || dayjs());
   if (data.location?.guid) {
      const selectedWarehouse = getSelectedWarehouseOption(data.location);
      setValue("location", selectedWarehouse.value || data.location);
    }
    // Map items properly
    const items = data.invSalesDetails.map((detail) => {
      const taxGuid =
        taxData.find((t) => Number(t.value) === Number(detail.taxPercentage))
          ?.guid || null;

      return {
        product: detail?.product?.guid,
        code: detail?.product?.code,
        batch: detail.batch,
        expiry: dayjs(detail.expiryDate),
        unit: detail.unit?.guid,
        quantity: detail.quantity,
        price: detail.price,
        mrp: detail.mrp,
        foc: detail.foc,
        discountPercentage: detail.discPercentage,
        discountAmount: detail.discAmt,
        taxPercentage: taxGuid, // GUID of the tax
        gross: detail.gross,
        taxAmount: detail.taxamnt,
        netTotal: detail.netAmt,
      };
    });

    setValue("items", items);
  }
}

useEffect(() => {
  if (data && taxData.length) {
    resetmodal();
  }
}, [data, taxData]);


  // useEffect(() => {
  //   resetmodal();
  // }, [data, setValue]);

  useEffect(() => {
    handleCustomerList();
  }, [customerList]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (mode === "add") {
  //       handleEntryNo();
  //       if (!isRowAdded && fields?.length === 0) {
  //         handleAddRow();
  //         setIsRowAdded(true);
  //       }
  //     }
  //     handleProductsList();

  //     handleTaxList();
  //     handleUnitList();
  //     handlesalesData();
  //     handleDiscountList();
  //   };

  //   fetchData();
  // }, []);

  useEffect(() => {
  const fetchData = async () => {
    if (mode === "add") {
      handleEntryNo();

      // Add first row if none exists
      if (!isRowAdded && fields?.length === 0) {
        handleAddRow();
        setIsRowAdded(true);
      }

      // Set default warehouse if exists
      const defaultWarehouse = getDefaultWarehouse();
      if (defaultWarehouse) {
        setValue("location", defaultWarehouse.value);
      }
    }

    handleProductsList();
    handleTaxList();
    handleUnitList();
    handlesalesData();
    handleDiscountList();
  };

  fetchData();
}, [branchsettings, warehouses]);

  const [products, setProducts] = useState([]);

  const handleProductsList = async () => {
    try {
      const formattedProducts = productList?.map((product) => ({
        label: product.name,
        value: product.guid,
        // carried so the picker can be searched by barcode as well as by name
        barcode: `${product.barcode ?? ""}`,
        code: `${product.code ?? ""}`,
      }));
      setProducts(formattedProducts);
    } catch (error) {
      console.error(
        "Error fetching products",
        error?.response?.data?.Message || "Unexpected error occured"
      );
    }
  };
  async function getCustomerByGuid(guid) {
    const response = await getCustomersList(branch);
    const filteredData = response.data?.filter(
      (customer) => customer.guid === guid
    );
    return filteredData[0];
  }

  async function getUnitByGuid(guid) {
    const unitData = await getUnitList();
    const filteredData = unitData?.filter((unit) => unit.guid === guid);
    return filteredData[0];
  }

  async function getTaxByGuid(guid) {
    const taxData = await getTaxList();
    const filteredData = taxData?.filter((tax) => tax.guid === guid);
    return filteredData[0];
  }

  async function getProductByGuid(guid) {
    const productData = await getProductList(branch);

    const filteredData = productData?.filter(
      (product) => product.guid === guid
    );

    return filteredData[0];
  }

  // const handleFormSubmit = async (formdata) => {
  //   console.log(getValues().row);
  // };
  const handleFormSubmit = async (formdata) => {
    const objsales = new InvSales();
    const objfinance = new FinancialYear();
    if (mode === "edit") {
      objsales.guid = data?.guid;
      objsales.id = data?.id;
    }
    objsales.entrynumber = formdata?.entrynumber || 0;
    objsales.branch = branch;
    // objsales.Entrynumber = formdata.invoiceNo || "";
    objsales.invdate = dayjs(formdata?.invdate)?.format("YYYY-MM-DDTHH:mm:ss");
    objsales.deliveryDate = dayjs(formdata?.deliveryDate)?.format(
      "YYYY-MM-DDTHH:mm:ss"
    );
    objsales.salesPaymentType = formdata?.paymentType;
    objsales.salesTransType = 2;
    objsales.reftype = formdata?.referencetype || 0;
    objsales.refNo = formdata?.refNo || "";
    const customerData = customerList?.find((e) => e.guid == formdata?.customer);
    objsales.location = formdata.location;
    objsales.updatedUser = `${userId?.id}`;
    objsales.createdUser = `${userId?.id}`;
    objsales.customer = customerData;
    objsales.currency = "00000000-0000-0000-0000-000000000000";

    objsales.dispatch = formdata?.dispatch || "";
    objsales.dispatchTrough = formdata?.dispatchTrough || "";
    objsales.salesMode = formdata?.salesMode || 0;
    objsales.paid = Number(formdata?.paid) || 0;
    objsales.change = Number(formdata.change) || 0.0;
    objsales.additionalAmt = Number(formdata.addition) || 0.0;
    objsales.discAmt = Number(formdata.subtraction) || 0;
    objsales.roundOff = Number(formdata.round) || 0;
    objsales.grossTotal = totalGross || 0.0;
    objsales.discountTotal = totalDiscount || 0.0;
    objsales.taxTotal = totalTax || 0.0;
    objsales.netTotal = totalNet || 0.0;
    objsales.customerName = formdata.customerName || "";
    objsales.customerContactno = formdata.customerContactno || "";
    objsales.terms = formdata.terms || "";
    // guid of the selected branch user - API/DB column still required
    objsales.salesman = formdata?.salesman || null;

    if (formdata.paymentType === 0) {
      objsales.cash = totalNet || 0;
    } else if (formdata.paymentType === 1) {
      objsales.bank = totalNet || 0;
    } else if (formdata.paymentType === 2) {
      objsales.upi = totalNet || 0;
    } else if (formdata.paymentType === 3) {
      objsales.card = totalNet || 0;
    }

    objfinance.id = branchsettings?.defaultFinancialYearID;
    objsales.financialYear = objfinance;
    objsales.Company = companyInfolist[0];
   
    const detailObj = formdata?.items?.filter((e) => !isBlankRow(e))?.map((e) => {
      const defaultDiscountobj = new DiscountClass();
      const defaultTaxobj = new TaxClass();

      let product;
      const productValue = e.product || e.product.value;

      product = productList?.find((item) => item.guid == productValue);
      const unit = unitList.find((item) => item.guid == e.unit);
      const taxPercentage=taxData?.find((item)=>item.guid==e.taxPercentage)?.value

      const expiry = e.expiry
        ? dayjs(e.expiry).format("YYYY-MM-DDTHH:mm:ss")
        : dayjs().format("YYYY-MM-DDTHH:mm:ss");

      const detailObj = {
        product,
        unit,
        batch: e.batch,
        expiryDate: expiry,
        quantity: e.quantity,
        price: e.price,
        mrp: e.mrp || 0.0,
        foc: e.foc || 0.0,
        taxamnt: e.taxAmount,
        grossAmount: e.gross,
        netAmt: e.netTotal,
        discAmt: e.discountAmount,
        discPercentage: e.discountPercentage,
        taxPercentage,
        // per-line note - needs a matching column on the API/DB side to persist
        notes: e.notes || "",
      };

      return detailObj;
    });
    objsales.invSalesDetails = detailObj;
    try {
      const response = await addEditSales(objsales);
      console.log(response,"salessssssss");
      
      if (response) {
        toast.success("Success");
        // print before the modal unmounts - handlePrint reads the live form
        if (printOnSave) {
          handlePrint(printPrefs?.format || "A4");
          setPrintOnSave(false);
        }
        handleRefresh(); // Refresh the list
        handleClose(); // Close the modal
      }
    } catch (error) {
      toast.error(error?.response?.data?.Message || "Unexpected error occured");
      console.error(
        "Error handling :",
        error?.response?.data?.Message || "Unexpected error occured"
      );
    }
  };

 

  // const printA4Function = () => {
  //   const form = document.getElementById("invoice-content");
  
  //   if (!form) {
  //     console.error("Element with ID 'invoice-content' not found.");
  //     return;
  //   }
  
  //   // Extract required values from form inputs

  //   const entryNumber = form.querySelector("input[name='entrynumber']")?.value || "";
  //   const date = form.querySelector("input[name='invdate']")?.value || "";
  //   const deliveryDate = form.querySelector("input[name='deliveryDate']")?.value || "";
  //   const customerName = form.querySelector("input[name='customerName']")?.value || "";
  //   const contactNumber = form.querySelector("input[name='customerContactno']")?.value || "";
  //   const discount = form.querySelector("input[name='discount']")?.value || "";
  //   const taxTotal = form.querySelector("input[name='taxTotal']")?.value || "";
  //   const netTotal = form.querySelector("input[name='netTotal']")?.value || "";
  
  //   // Extract table data
  //   const tableRows = Array.from(form.querySelectorAll("table tbody tr")).map((row) => {
  //     return {
  //       description: row.querySelector(".description")?.innerText || "",
  //       rate: row.querySelector(".rate")?.innerText || "",
  //       qty: row.querySelector(".qty")?.innerText || "",
  //       total: row.querySelector(".total")?.innerText || "",
  //     };
  //   });
  
  //   // Generate printable content
  //   const printableContent = `
  //     <html>
  //       <head>
  //         <title>Invoice</title>
  //         <style>
  //           body { font-family: Arial, sans-serif; padding: 20px; }
  //           table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  //           th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
  //           .text-right { text-align: right; }
  //         </style>
  //       </head>
  //       <body>
  //         <h2>Invoice</h2>
  //         <p><strong>Entry No:</strong> ${entryNumber}</p>
  //         <p><strong>Date:</strong> ${date}</p>
  //         <p><strong>Delivery Date:</strong> ${deliveryDate}</p>
  //         <p><strong>Customer Name:</strong> ${customerName}</p>
  //         <p><strong>Contact Number:</strong> ${contactNumber}</p>
  
  //         <table>
  //           <thead>
  //             <tr>
  //               <th>Description</th>
  //               <th>Rate</th>
  //               <th>Qty</th>
  //               <th>Total</th>
  //             </tr>
  //           </thead>
  //           <tbody>
  //             ${tableRows
  //               .map(
  //                 (row) => `
  //               <tr>
  //                 <td>${row.description}</td>
  //                 <td>${row.rate}</td>
  //                 <td>${row.qty}</td>
  //                 <td>${row.total}</td>
  //               </tr>
  //             `
  //               )
  //               .join("")}
  //           </tbody>
  //         </table>
  
  //         <p><strong>Discount:</strong> ${discount}</p>
  //         <p><strong>Tax Total:</strong> ${taxTotal}</p>
  //         <p><strong>Net Total:</strong> ${netTotal}</p>
  
  //       </body>
  //     </html>
  //   `;
  
  //   // Open print window
  //   const newWindow = window.open("", "_blank");
  //   newWindow.document.write(printableContent);
  //   newWindow.document.close();
  
  //   // Delay print execution to ensure styles are applied
  //   setTimeout(() => {
  //     newWindow.print();
  //     newWindow.onafterprint = () => newWindow.close(); // Auto-close after printing
  //   }, 500);
  // };
  
const generateFatooraQR = (sellerName, invoiceDate, invoiceTotal, vatTotal) => {
  const encodeTLV = (tag, value) => {
    const safeValue = value ? String(value) : "";
    const tagBuffer = Buffer.from([tag]);
    const lengthBuffer = Buffer.from([safeValue.length]);
    const valueBuffer = Buffer.from(safeValue, "utf8");

    return Buffer.concat([tagBuffer, lengthBuffer, valueBuffer]);
  };

  const qrBuffer = Buffer.concat([
    encodeTLV(1, sellerName),
    encodeTLV(2, invoiceDate),
    encodeTLV(3, invoiceTotal),
    encodeTLV(4, vatTotal),
  ]);

  return qrBuffer.toString("base64");
};


  const printA4Function = async() => {
    const form = document.getElementById("invoice-content");
  
    if (!form) {
      console.error("Element with ID 'invoice-content' not found.");
      return;
    }

   // const company = companyInfolist.length > 0 ? companyInfolist[0] : {}; // Assuming single company info
const company = printSettings?.[0] ?? {};

console.log("Company Info for Printing:", company); 
    // Extract company details
    const companyName = company.companyName;
    const otherLanguage = company.otherLanguage || "";
    const companyAddress1 = company.header1 || "";
    const companyAddress2 = company.header2 || "";
    const companyAddress3 = company.header3 || "";
    const companyAddress4 = company.header4 || "";
    const companyAddress5 = company.header5 || "";
    // const companyPhone = company.phone || "";
    // const companyVAT = company.tin || "";
    // Extract values from form inputs
    

    
         const supplierGuid = watch("customer");
   const supplierObj = customerList.find(sup => sup.guid === supplierGuid) || {};
   const supplierName = supplierObj.name || supplierObj.ledger || "N/A";
   const supplierAddress1 = supplierObj.address1 || "";
   const supplierMobile = supplierObj.mobile || "";
   const supplierVAT = supplierObj.gstNo || "";   
    
    const entryNumber = form.querySelector("input[name='entrynumber']")?.value || "";

const date = new Date(watch("invdate")).toLocaleDateString("en-GB"); // Format: DD/MM/YYYY
const deliveryDate = new Date(watch("deliveryDate")).toLocaleDateString("en-GB");
const invDateValue = watch("invdate") || new Date().toISOString();
  const invoiceDate = new Date(invDateValue).toISOString();
    const customerName = form.querySelector("input[name='customerName']")?.value || "";
    const contactNumber = form.querySelector("input[name='customerContactno']")?.value || "";
    const fields = watch("items") || [];
// const discount = fields.reduce((sum, item) => sum + (parseFloat(item.discountAmount) || 0), 0);
// const taxTotal = fields.reduce((sum, item) => sum + (parseFloat(item.taxAmount) || 0), 0);
const  netTotal = fields.reduce((sum, item) => sum + (parseFloat(item.netTotal) || 0), 0);
// const addition = parseFloat(watch("addition")) || 0;
// const round = parseFloat(watch("round")) || 0;
// Store the totals in React Hook Form
// setValue("discount", discount.toFixed(2));
// setValue("taxTotal", taxTotal.toFixed(2));
// setValue("netTotal", netTotal.toFixed(2));

const grossTotalPrint = Number(totalGross) || 0;
const discountPrint = Number(totalDiscount) || 0;
const taxTotalPrint = Number(totalTax) || 0;
const netTotalPrint = Number(totalNet) || 0;

const additionPrint = Number(watch("addition")) || 0;
const roundPrint = Number(watch("round")) || 0;


console.log({ totalDiscount, totalTax, totalNet });

  
    // Extract table data
  

  // const tableRows = Array.from(form.querySelectorAll("table tbody tr")).map(row => {
  //   // Query the react-select component for the current row
  //   const selectContainer1 = row?.querySelector('.css-b62m3t-container');
  //   const selectContainer = selectContainer1?.querySelector('.react-select__control');
  //   const selectContainer3 = selectContainer?.querySelector('.react-select__value-container');
  //   const selectedValueDiv = selectContainer3?.querySelector('.react-select__single-value');
  
  //   // Extract the text or value of the selected option
  //   const selectedValue = selectedValueDiv?.textContent || "N/A";
  
  //   // Extract other values from the row (quantity, rate, total)
  //   return {
  //     description: selectedValue,
  //     qty: parseInt(row.querySelector("td:nth-child(6) input")?.value?.trim()) || 0,
  //     rate: parseFloat(row.querySelector("td:nth-child(7) input")?.value?.trim()) || 0.00,
  //     total: parseFloat(row.querySelector("td:nth-child(10) input")?.value?.trim()) || 0.00
  //   };
  // });
const paymentTypeLabel =
  paymentType?.find(p => p.value === watch("paymentType"))?.label || "";


  //     const tableRows = Array.from(form.querySelectorAll("tbody tr")).map((row, index) => ({
  //   description: row.querySelector('td[data-label="Description"]')?.innerText || "",
  //   code: row.querySelector('td[data-label="Item Code"] input')?.value || "",
  //   hsnCode: row.querySelector('td[data-label="HSN Code"] input')?.value || "",
  //   qty: parseFloat(row.querySelector('td[data-label="Quantity"] input')?.value || 0),
  //   unit: row.querySelector('td[data-label="Unit"] input')?.value || "",
  //   rate: parseFloat(row.querySelector('td[data-label="Price"] input')?.value || 0),
  //   discount: parseFloat(row.querySelector('td[data-label="Discount Amount"] input')?.value || 0),
  //   tax: parseFloat(row.querySelector('td[data-label="Tax Amount"] input')?.value || 0),
  //   total: parseFloat(row.querySelector('td[data-label="Gross"] input')?.value || 0),
  //   netTotal: parseFloat(row.querySelector('td[data-label="Net Amount"] input')?.value || 0),
  // }));
  const tableRows = Array.from(form.querySelectorAll("tbody tr"))
    .filter(
      (row) =>
        parseFloat(
          row.querySelector('td[data-label="Quantity"] input')?.value || 0
        ) > 0
    )
    .map((row) => {
  const unitText =
    row
      .querySelector('td[data-label="Unit"] .react-select__single-value')
      ?.textContent || "";

  return {
    description: row.querySelector('td[data-label="Description"]')?.innerText || "",
    code: row.querySelector('td[data-label="Barcode"] input')?.value || "",
    qty: parseFloat(row.querySelector('td[data-label="Quantity"] input')?.value || 0),
    unit: unitText,
    rate: parseFloat(row.querySelector('td[data-label="Price"] input')?.value || 0),
    tax: parseFloat(row.querySelector('td[data-label="Tax Amount"] input')?.value || 0),
      discount: parseFloat(row.querySelector('td[data-label="Discount Amount"] input')?.value || 0),
    total: parseFloat(row.querySelector('td[data-label="Gross"] input')?.value || 0),
    netTotal: parseFloat(row.querySelector('td[data-label="Net Amount"] input')?.value || 0),
  };
});

  console.log(tableRows,"lkkk");

  // const qrData = `Company: ${companyName}\nDate: ${date}\nDelivery Date: ${deliveryDate}\nNet Total: ${netTotal.toFixed(2)}`;
    
  //   const qrCodeUrl = await QRCode.toDataURL(qrData);

  const fatooraQRData = generateFatooraQR(companyName, invoiceDate, netTotalPrint.toFixed(2), taxTotalPrint.toFixed(2));
  const qrCodeUrl = await QRCode.toDataURL(fatooraQRData);
  
    // Generate printable content
    // const printableContent = `
    //   <html>
    //     <head>
    //       <title>Invoice</title>
    //       <style>
    //         body { font-family: Arial, sans-serif; padding: 20px; }
    //         table { width: 100%; border-collapse: collapse; margin-top: 10px; }
    //         .header { text-align: center; margin-bottom: 20px; }
    //         .qr-code { text-align: center; margin-top: 20px;}
    //         th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
    //         .text-right { text-align: right; }
    //         .totals-table { width: 100%; margin-top: 20px; border-collapse: collapse; }
    //         .totals-table td { border: none; padding: 5px; font-weight: bold; }
    //         .totals-table .label { text-align: right; width: 80%; }
    //         .totals-table .value { text-align: right; width: 20%; }
    //         @media print {
    //           body { margin: 0; }
    //         }
    //       </style>
    //     </head>
    //     <body>
    //       <div class="qr-code">
    //         <img src="${qrCodeUrl}" alt="QR Code" />
    //       </div>
    //      <div class="header">
    //         <h2>${companyName}</h2>
    //         <p>${companyAddress1}, ${companyAddress2}, ${companyAddress3}</p>
    //         <p>Phone: ${companyPhone}</p>
    //       </div>
         
    //       <p><strong>Entry No:</strong> ${entryNumber}</p>
    //       <p><strong>Date:</strong> ${date}</p>
    //       <p><strong>Delivery Date:</strong> ${deliveryDate}</p>
    //       <p><strong>Customer Name:</strong> ${customerName}</p>
    //       <p><strong>Contact Number:</strong> ${contactNumber}</p>
  
    //       <table>
    //         <thead>
    //           <tr>
    //             <th>Description</th>
    //             <th>Rate</th>
    //             <th>Qty</th>
    //             <th>Total</th>
    //           </tr>
    //         </thead>
    //         <tbody>
    //           ${tableRows
    //             .map(
    //               (row) => `
    //             <tr>
    //               <td>${row.description}</td>
    //               <td class="text-right">${row.rate.toFixed(2)}</td>
    //               <td class="text-right">${row.qty}</td>
    //               <td class="text-right">${row.total.toFixed(2)}</td>
    //             </tr>
    //           `
    //             )
    //             .join("")}
    //         </tbody>
    //       </table>
  
    //       <table class="totals-table">
    //         <tr>
    //           <td class="label">Discount:</td>
    //           <td class="value">${discount}</td>
    //         </tr>
    //         <tr>
    //           <td class="label">Tax Total:</td>
    //           <td class="value">${taxTotal}</td>
    //         </tr>
    //         <tr>
    //           <td class="label">Net Total:</td>
    //           <td class="value">${netTotal}</td>
    //         </tr>
    //       </table>
    //     </body>
    //   </html>
    // `;
  

const amountInWords = (num) => {
  if (!num || isNaN(num)) return "";

  const a = [
    "", "One", "Two", "Three", "Four", "Five",
    "Six", "Seven", "Eight", "Nine", "Ten",
    "Eleven", "Twelve", "Thirteen", "Fourteen",
    "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];

  const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

  const numberToWords = (n) => {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
    if (n < 1000)
      return (
        a[Math.floor(n / 100)] +
        " Hundred" +
        (n % 100 ? " " + numberToWords(n % 100) : "")
      );
    if (n < 1000000)
      return (
        numberToWords(Math.floor(n / 1000)) +
        " Thousand" +
        (n % 1000 ? " " + numberToWords(n % 1000) : "")
      );
    return "";
  };

  const integerPart = Math.floor(num);
  const decimalPart = Math.round((num - integerPart) * 100);

  const riyalPart = numberToWords(integerPart);
  const halalahPart = decimalPart ? numberToWords(decimalPart) : "";

  return `${riyalPart} Riyal${
    halalahPart ? " and " + halalahPart + " Halalah" : ""
  } Only`;
};


const printableContent = `
<!DOCTYPE html>
<html lang="ar">
<head>
<meta charset="UTF-8" />
<title>Tax Invoice</title>

<style>
@page { size: A4; margin: 10mm; }

body {
  font-family: Arial, sans-serif;
  font-size: 11px;
  color: #000;
}

.center { text-align: center; }
.left { text-align: left; direction: ltr; }
.right { text-align: right; direction: rtl; }
.bold { font-weight: bold; }
.header h2 {
  margin: 2px 0;
}
.header p { margin: 2px 0; }

.invoice-title {
  margin: 16px 16px;
  font-weight: bold;
  
}

/* DEFAULT TABLE */
table {
  width: 100%;
  border-collapse: collapse;
}

/* HEADER & INFO TABLES */
th {
  border: 1px solid #000;
  padding: 4px;
}

.header table td,
table:not(.items) td {
  border: 1px solid #000;
  padding: 4px;
}

/* ITEMS TABLE OUTER BORDER */
.items {
  border: 1px solid #000;
}

/* ITEM HEADER GRID */
.items thead th {
  border: 1px solid #000;
}

/* ITEM BODY — NO VERTICAL LINES */
/* ITEM BODY — ONLY VERTICAL LINES (REFERENCE STYLE) */
.items tbody td {
  border-top: none;
  border-bottom: none;
  border-left: 1px solid #000;
  border-right: 1px solid #000;
  padding: 6px 4px;
  text-align: center;
  height: 26px;
}




/* BOTTOM BORDER OF ITEMS */
.items tbody tr:last-child td {
  border-bottom: 1px solid #000;
}


.small { font-size: 10px; }

.no-border tr td { border: none; }

.items th { font-size: 10px; }
.items td { font-size: 11px; text-align: center; }

/* FORCE ITEM TABLE HEIGHT */
.items tbody {
  height: 380px;
}
.totals{
border: 1px solid #000;
}
.totals tr td {
   border-top: none;
  border-bottom: none;
  border-left: none;
  border-right: none;
  padding: 6px 4px;
}
.totals td:last-child {
  border-left: 1px solid #000;
}

.footer-fixed {
  margin-top: 8px;
  font-size: 10px;
  border: 1px solid #000;
}

.footer-fixed tr td {
  border: none;
}
</style>
</head>

<body>

<!-- HEADER (UNCHANGED AS REQUESTED) -->
<div class="header center">
<h2>${otherLanguage}</h2>
  <h2>${companyName}</h2>
 
  <p>${companyAddress1}</p>
  <p>${companyAddress2}</p>
  <p>${companyAddress3}</p>
  <p>${companyAddress4}</p>
  <p>${companyAddress5}</p>

 

  <div class="invoice-title">TAX INVOICE &nbsp;&nbsp; الفاتورة الضريبية</div>
</div>

<!-- INVOICE INFO -->
<table>
<tr>
  <td class="left small"><b>Invoice No :</b> ${entryNumber}</td>
  <td class="center small"><b>Date :</b> ${date}</td>
  <td class="right small"><b>Type :</b> ${paymentTypeLabel}</td>
</tr>
</table>

<!-- CUSTOMER DETAILS -->
<table style="margin-top:4px;">
<tr>
  <th colspan="4" class="center small">CUSTOMER DETAILS &nbsp;&nbsp; تفاصيل العميل</th>
</tr>
<tr>
  <td class="left small"><b>NAME</b></td>
  <td class="left">${supplierName}</td>
  <td></td>
  <td class="right small"><b>اسم</b></td>

</tr>
<tr>
  <td class="left small"><b>CONTACT</b></td>
  <td class="left">${supplierMobile}</td>
  <td>${supplierMobile}</td>
  <td class="right small"><b>رقم الاتصال</b></td> 
</tr>
<tr>
  <td class="left small"><b>VAT NO</b></td>
  <td class="left">${supplierVAT}</td>
    <td>${supplierVAT}</td>
  <td class="right small"><b>الرقم الضريبي</b></td>

</tr>
<tr>
  <td class="left small"><b>CR NO</b></td>
  <td class="left"></td>
    <td></td>
  <td class="right small"><b>رقم السجل التجاري</b></td>

</tr>
<tr>
  <td class="left small"><b>ADDRESS</b></td>
  <td colspan="3">${supplierAddress1}</td>
</tr>
</table>

<!-- ITEMS -->
<table class="items" style="margin-top:4px;">
<thead>
<tr>
  <th>Sl.No<br/>رقم</th>
  <th>Barcode<br/>الباركود</th>
  <th>Description<br/>الوصف</th>
  <th>Qty<br/>كمية</th>
  <th>Unit<br/>وحدة</th>
  <th>Unit Price<br/>سعر الوحدة</th>
  <th>Taxable Amt<br/>المبلغ الخاضع</th>
  <th>Tax Amt<br/>مبلغ الضريبة</th>
  <th>Total<br/>المجموع</th>
</tr>
</thead>

<tbody>
${
(() => {
  const minRows = 9;
  const emptyRows = minRows - tableRows.length;

  return `
  ${tableRows.map((row, i) => `
  <tr>
    <td>${i + 1}</td>
    <td>${row.code}</td>
    <td class="left">${row.description}</td>
    <td>${row.qty}</td>
    <td>${row.unit}</td>
    <td>${row.rate.toFixed(2)}</td>
    <td>${row.total.toFixed(2)}</td>
    <td>${row.tax.toFixed(2)}</td>
    <td>${row.netTotal.toFixed(2)}</td>
  </tr>
  `).join("")}

  ${Array.from({ length: Math.max(0, emptyRows) }).map(() => `
  <tr>
    <td>&nbsp;</td><td></td><td></td><td></td>
    <td></td><td></td><td></td><td></td><td></td>
  </tr>
  `).join("")}
  `;
})()
}
</tbody>
</table>

<!-- TOTALS -->
<table class="totals" style="margin-top:6px;">
<tr>
  <td class="left small">
VAT (${((taxTotalPrint / (netTotalPrint - taxTotalPrint)) * 100).toFixed(2)}%)
  </td>
  <td></td>
  <td class="right bold" style="padding-right:16px;">Total</td><td>المجموع</td> 
  <td class="right">${(netTotalPrint - taxTotalPrint).toFixed(2)}</td>
</tr>
<tr>
  <td colspan="2"></td>
  <td class="right bold" style="padding-right:16px;">VAT</td><td>ضريبة القيمة المضافة</td> 
  <td class="right">${taxTotalPrint.toFixed(2)}</td>
</tr>
<tr>
  <td colspan="2"></td>
  <td class="right bold" style="padding-right:16px;">Discount </td><td> تخفيض</td> 
  <td class="right">${discountPrint.toFixed(2)}</td>
</tr>
<tr>
  <td colspan="2"></td>
  <td class="right bold" style="padding-right:16px;">Sub Total </td><td>المجموع الفرعي</td> 
  <td class="right">${netTotal.toFixed(2)}</td>
</tr>

<tr>
  <td colspan="2"></td>
  <td class="right bold" style="padding-right:16px;">Addition</td><td>إضافة</td> 
  <td class="right">${additionPrint.toFixed(2)}</td>
</tr>
<tr>
  <td colspan="2"></td>
  <td class="right bold" style="padding-right:16px;">Round off</td><td >تقريب</td> 
  <td class="right">${roundPrint.toFixed(2)}</td>
</tr>
<tr>
  <td class="left bold">
     ${amountInWords(netTotalPrint)}
  </td>
  <td></td>
  <td class="right bold" style="padding-right:16px;">Net Total</td><td class="bold">صافي المجموع</td> 
  <td class="right bold">${netTotalPrint.toFixed(2)}</td>
</tr>
</table>

<!-- QR & FOOTER -->
<table class="footer-fixed">
<tr>
  <td class="left" style="padding-left:20px;">
    <img src="${qrCodeUrl}" width="100" />
  </td>
  <td class="right bold" style="font-size:12px; padding-right:20px;">
    For ${companyName}<br/>
  </td>
</tr>
</table> 

</body>
</html>
`;



    // Create an iframe for better printing
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0px";
    iframe.style.height = "0px";
    iframe.style.border = "none";
    document.body.appendChild(iframe);
  
    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(printableContent);
    doc.close();
  
    iframe.contentWindow.focus();
    setTimeout(() => {
      iframe.contentWindow.print();
      iframe.contentWindow.onafterprint = () => document.body.removeChild(iframe);
    }, 500);
  };
  





const  thermalPrintFunction = async() => {
  const form = document.getElementById("invoice-content");

  if (!form) {
      console.error("Element with ID 'invoice-content' not found.");
      return;
  }

const company = printSettings?.[0] ?? {};

    // Extract company details
    const companyName = company.companyName;
    const otherLanguage = company.otherLanguage;
    const companyAddress1 = company.header1 ;
    const companyAddress2 = company.header2 ;
    const companyAddress3 = company.header3 ;
    const companyAddress4 = company.header4;
    const companyAddress5 = company.header5 ;
  //const companyPhone = company.phone || "";
  //const companyVAT = company.tin || "";
const footerText1= company.footerText1 ;
const footerText2= company.footerText2 ;

  // Helper function to get input values safely
  const entryNumber = form.querySelector("input[name='entrynumber']")?.value || "";
   
    
  // const date = watch("invdate"); // Automatically updates when field changes
  // const deliveryDate = watch("deliveryDate");
  const date = new Date(watch("invdate")).toLocaleDateString("en-GB"); // Format: DD/MM/YYYY
  const deliveryDate = new Date(watch("deliveryDate")).toLocaleDateString("en-GB");
  const invDateValue = watch("invdate") || new Date().toISOString();
  const invoiceDate = new Date(invDateValue).toISOString();
      const customerName = form.querySelector("input[name='customerName']")?.value || "";
      const contactNumber = form.querySelector("input[name='customerContactno']")?.value || "";
      
      const fields = watch("items") || [];

  // Calculate totals
  const discount = fields.reduce((sum, item) => sum + (parseFloat(item.discountAmount) || 0), 0);
  const taxTotal = fields.reduce((sum, item) => sum + (parseFloat(item.taxAmount) || 0), 0);
  const netTotal = fields.reduce((sum, item) => sum + (parseFloat(item.netTotal) || 0), 0);

  // Store the totals in React Hook Form
  setValue("discount", discount.toFixed(2));
  setValue("taxTotal", taxTotal.toFixed(2));
  setValue("netTotal", netTotal.toFixed(2));
    
 

  // Extract table data
 
  const tableRows = Array.from(form.querySelectorAll("table tbody tr"))
    .filter(
      (row) =>
        parseFloat(
          row.querySelector('td[data-label="Quantity"] input')?.value || 0
        ) > 0
    )
    .map(row => {
    // Query the react-select component for the current row
    const selectContainer1 = row?.querySelector('.css-b62m3t-container');
    const selectContainer = selectContainer1?.querySelector('.react-select__control');
    const selectContainer3 = selectContainer?.querySelector('.react-select__value-container');
    const selectedValueDiv = selectContainer3?.querySelector('.react-select__single-value');
  
    // Extract the text or value of the selected option
    const selectedValue = selectedValueDiv?.textContent || "N/A";
  
    // Extract other values from the row (quantity, rate, total)
    return {
      description: selectedValue,
      qty: parseInt(row.querySelector('td[data-label="Quantity"] input')?.value?.trim()) || 0,
      rate: parseFloat(row.querySelector('td[data-label="Price"] input')?.value?.trim()) || 0.00,
      total: parseFloat(row.querySelector('td[data-label="Gross"] input')?.value?.trim()) || 0.00
    };
  });
   
  // const qrData = `Seller's Name: ${companyName}\nInvoice Date/Time: ${date}\nInvoice Total(with VAT ): ${netTotal.toFixed(2)}`;
    
  // const qrCodeUrl = await QRCode.toDataURL(qrData);

  const fatooraQRData = generateFatooraQR(companyName, invoiceDate, netTotal.toFixed(2), taxTotal.toFixed(2));
  const qrCodeUrl = await QRCode.toDataURL(fatooraQRData);

  // Format content for thermal printing (3-inch width)
  const printableContent = `
  <html>
  <head>
    <title>Receipt</title>
    <style>
      body { 
        font-family: Arial, sans-serif; 
        font-size: 8vw; /* Responsive font size */
        width: 100%; 
        max-width: 300px; /* Ensures it fits on small screens */
        margin: 0 auto; /* Center content */
        padding: 0;
        word-wrap: break-word; /* Prevents overflow */
      }
      .header { text-align: center;}
      .header h2{
      margin: 1px 0;
      }
      .header p{  
      margin :1px 0;
      }

       .qr-code { text-align: center; margin-top: 20px;}
      .center { text-align: center; }
      .bold { font-weight: bold; }
      .uppercase { text-transform: uppercase; }
      .line { border-top: 2px dashed black; margin: 12px 0; } 
      .table { width: 100%; border-collapse: collapse; font-size: 8vw; } /* Responsive table font */
      .table td {
        padding: 8px; /* More spacing */
        word-wrap: break-word;
      }
      .right { text-align: right; }
      .title { font-size: 10vw; } /* Scales title */
      .total { font-size: 10vw; font-weight: bold; } /* Larger total */
      
      /* Responsive design for smaller screens */
      @media (max-width: 400px) {
        body { font-size: 4.5vw; }
        .table { font-size: 4.5vw; }
        .title, .total { font-size: 4.5vw; }
      }
 
      @media (min-width: 600px) {
        body { font-size: 10px; }
        .table { font-size: 10px; }
        .title, .total { font-size: 15px; }
      }

     @media print {
        @page { margin: 5mm; } /* Adds margin for print */
        body { margin: 0; padding: 0; }
        .line { margin: 10px 0; }
      }
    </style>
  </head>
  <body>
   
  <div class="header">
         <h2>${otherLanguage}</h2>
  <h2>${companyName}</h2>
 
  <p>${companyAddress1}</p>
  <p>${companyAddress2}</p>
  <p>${companyAddress3}</p>
  <p>${companyAddress4}</p>
  <p>${companyAddress5}</p>
          </div>
    
    <div class="line"></div>
    <div>Entry No: ${entryNumber}</div>
    <div>Date: ${new Date(date).toLocaleDateString()}</div>
    <div>Delivery Date: ${new Date(deliveryDate).toLocaleDateString()}</div>
    <div>Customer: ${customerName}</div>
    <div>Contact: ${contactNumber}</div>
    <div class="line"></div>

    <table class="table">
      <tr class="bold">
        <td>Description</td>
        <td class="right">Qty</td>
        <td class="right">Rate</td>
        <td class="right">Total</td>
      </tr>
      ${tableRows.map(row => ` 
        <tr>
          <td>${row.description}</td>
          <td class="right">${row.qty}</td>
          <td class="right">${row.rate.toFixed(2)}</td>
          <td class="right">${row.total.toFixed(2)}</td>
        </tr>
      `).join("")}
    </table>

    <div class="line"></div>
    <table class="table">
      <tr>
        <td class="bold">Discount:</td>
        <td class="right">${discount.toFixed(2)}</td>
      </tr>
      <tr>
        <td class="bold">Tax:</td>
        <td class="right">${taxTotal.toFixed(2)}</td>
      </tr>
      <tr>
        <td class="bold total">Total:</td>
        <td class="right total">${netTotal.toFixed(2)}</td>
      </tr>
    </table>
    <div class="line"></div>
    <div class="center bold" style="font-size: 5vw;">${footerText1}</div>
    <div class="center bold" style="font-size: 5vw;">${footerText2}</div>
    <div class="center" style="font-size: 3vw;">Copyright(C)ezyERP .www.ezyerp.net</div>
    <div class="qr-code">
            <img src="${qrCodeUrl}" alt="QR Code" />
          </div>
  </body>
</html>




  `;

  // Print via iframe
  const iframe = document.createElement("iframe");
  iframe.style.position = "absolute";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "none";
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(printableContent);
  doc.close();

  iframe.contentWindow.focus();
  setTimeout(() => {
      iframe.contentWindow.print();
      iframe.contentWindow.onafterprint = () => iframe.remove();
  }, 500);
};



const amountInWords = (num) => {
  if (!num || isNaN(num)) return "";

  const a = [
    "", "One", "Two", "Three", "Four", "Five",
    "Six", "Seven", "Eight", "Nine", "Ten",
    "Eleven", "Twelve", "Thirteen", "Fourteen",
    "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];

  const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

  const numberToWords = (n) => {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
    if (n < 1000)
      return (
        a[Math.floor(n / 100)] +
        " Hundred" +
        (n % 100 ? " " + numberToWords(n % 100) : "")
      );
    if (n < 1000000)
      return (
        numberToWords(Math.floor(n / 1000)) +
        " Thousand" +
        (n % 1000 ? " " + numberToWords(n % 1000) : "")
      );
    return "";
  };

  const integerPart = Math.floor(num);
  const decimalPart = Math.round((num - integerPart) * 100);

  const riyalPart = numberToWords(integerPart);
  const halalahPart = decimalPart ? numberToWords(decimalPart) : "";

  return `${riyalPart} Riyal${
    halalahPart ? " and " + halalahPart + " Halalah" : ""
  } Only`;
};


const pdfFunction = async () => {
  const doc = new jsPDF("p", "mm", "a4");

  /* ================= DATA ================= */
const company = printSettings?.[0] ?? {};

console.log("Company Info for Printing:", company); 
    // Extract company details
    const companyName = company.companyName || "Company Name";
    const otherLanguage = company.otherLanguage || "";
    const companyAddress1 = company.header1 || "";
    const companyAddress2 = company.header2 || "";
    const companyAddress3 = company.header3 || "";
    const companyAddress4 = company.header4 || "";
    const companyAddress5 = company.header5 || "";
  const items = watch("items") || [];
  const date = new Date(watch("invdate")).toLocaleDateString("en-GB");

  const supplierGuid = watch("customer");
  const supplierObj =
    customerList.find(sup => sup.guid === supplierGuid) || {};

  const supplierName = supplierObj.name || supplierObj.ledger || "N/A";
  const supplierAddress1 = supplierObj.address1 || "";
  const supplierMobile = supplierObj.mobile || "";
  const supplierVAT = supplierObj.gstNo || "";

  const paymentTypeLabel =
    paymentType?.find(p => p.value === watch("paymentType"))?.label || "";

  /* ================= PAGE BORDER ================= */
  doc.rect(5, 5, 200, 287);

  /* ================= COMPANY HEADER ================= */
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text(companyName || "", 105, 12, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(companyAddress1, 80, 18, { align: "center" });
  doc.text(companyAddress2, 100, 18, { align: "center" });
  doc.text(companyAddress3 || "", 125, 18, { align: "center" });
  doc.text(companyAddress4 || "", 80, 22, { align: "center" });
  doc.text(companyAddress5 || "", 115, 22, { align: "center" });

  /* ================= TITLE ================= */
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("TAX INVOICE", 105, 32, { align: "center" });

  /* ================= META ROW ================= */
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);

  doc.rect(5, 36, 200, 10);
  doc.line(75, 36, 75, 46);
  doc.line(140, 36, 140, 46);

  doc.text(`Invoice No : ${watch("entrynumber")}`, 7, 43);
  doc.text(`Date : ${date}`, 77, 43);
  doc.text(`Type : ${paymentTypeLabel}`, 142, 43);

  /* ================= CUSTOMER DETAILS ================= */
  doc.setFont("helvetica", "bold");
 doc.line(5, 56, 205, 56);
  doc.text("CUSTOMER DETAILS", 105, 54, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.rect(5, 46, 200, 40);
  doc.line(105, 56, 105, 86);

  doc.line(5, 64, 205, 64);
  doc.line(5, 72, 205, 72);
  // doc.line(5, 80, 205, 80);
  // doc.line(5, 88, 205, 88);

  doc.text("NAME", 7, 62);
  doc.text(supplierName, 35, 62);

  doc.text("CONTACT", 7, 70);
  doc.text(supplierMobile, 35, 70);

  doc.text("VAT NO", 107, 70);
  doc.text(supplierVAT, 135, 70);

  doc.text("ADDRESS", 7, 78);
  doc.text(supplierAddress1, 35, 78);

  doc.text("CR NO", 107, 62);
  doc.text("-", 135, 62);

  /* ================= ITEMS TABLE ================= */
  const startY = 86;
  const rowH = 8;
  const tableHeight = 120;

  const colX = [5, 15, 35, 85, 100, 115, 135, 155, 175, 205];

  doc.rect(5, startY, 200, tableHeight);
  colX.forEach(x => doc.line(x, startY, x, startY + tableHeight));

  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);

  const headers = [
    "#",
    "Code",
    "Description",
    "Qty",
    "Unit",
    "Rate",
    "Taxable",
    "VAT",
    "Total",
  ];

  headers.forEach((h, i) => {
    doc.text(h, colX[i] + 2, startY + 6);
  });

  doc.line(5, startY + rowH, 205, startY + rowH);

  doc.setFont("helvetica", "normal");

  items.forEach((item, i) => {
    const y = startY + rowH * (i + 1) + 6;

    const product = productList.find(p => p.guid === item.product);
    const unit = unitList.find(u => u.guid === item.unit);

    doc.text(String(i + 1), colX[0] + 2, y);
    doc.text(product?.code || "", colX[1] + 2, y);
    doc.text(product?.name || "", colX[2] + 2, y);
    doc.text(String(item.quantity || 0), colX[3] + 2, y);
    doc.text(unit?.name || "", colX[4] + 2, y);
    doc.text(Number(item.price || 0).toFixed(2), colX[5] + 2, y);
    doc.text(Number(item.gross || 0).toFixed(2), colX[6] + 2, y);
    doc.text(Number(item.taxAmount || 0).toFixed(2), colX[7] + 2, y);
    doc.text(Number(item.netTotal || 0).toFixed(2), colX[8] + 2, y);

    doc.line(
      5,
      startY + rowH * (i + 2),
      205,
      startY + rowH * (i + 2)
    );
  });

  /* ================= FOOTER ================= */

// let footerStartY = startY + tableHeight + 5;

const PAGE_BOTTOM = 280;
const FOOTER_HEIGHT = 70;

let footerStartY = PAGE_BOTTOM - FOOTER_HEIGHT;


// A4 safety
if (footerStartY + 70 > 280) {
  doc.addPage();
  footerStartY = 20;
}

// Footer container
const footerHeight = 70;
doc.rect(5, footerStartY, 200, footerHeight);

// Divider between totals & QR
doc.line(5, footerStartY + 40, 205, footerStartY + 40);

// Vertical divider for totals (top half only)
doc.line(120, footerStartY, 120, footerStartY + 40);

/* ===== RIGHT SIDE TOTALS ===== */
const grossTotal = items.reduce((s, i) => s + Number(i.gross || 0), 0);
const taxTotal = items.reduce((s, i) => s + Number(i.taxAmount || 0), 0);
const netTotal = items.reduce((s, i) => s + Number(i.netTotal || 0), 0);

doc.setFont("helvetica", "normal");
doc.setFontSize(9);

const labelX = 125;
const valueX = 195;
let y = footerStartY + 8;
const gap = 5;

doc.text("Total", labelX, y);
doc.text(grossTotal.toFixed(2), valueX, y, { align: "right" });

y += gap;
doc.text("VAT", labelX, y);
doc.text(taxTotal.toFixed(2), valueX, y, { align: "right" });

y += gap;
doc.text("Discount", labelX, y);
doc.text("0.00", valueX, y, { align: "right" });

y += gap;
doc.text("Sub Total", labelX, y);
doc.text(netTotal.toFixed(2), valueX, y, { align: "right" });

y += gap;
doc.text("Addition", labelX, y);
doc.text("0.00", valueX, y, { align: "right" });

y += gap;
doc.text("Round off", labelX, y);
doc.text("0.00", valueX, y, { align: "right" });

// Net Total (bold, safely above divider)
y += gap;
doc.setFont("helvetica", "bold");
doc.text("Net Total", labelX, y);
doc.text(netTotal.toFixed(2), valueX, y, { align: "right" });

/* ===== LEFT SIDE ===== */
doc.setFont("helvetica", "normal");
doc.text("VAT (5.00%)", 7, footerStartY + 8);

doc.setFont("helvetica", "bold");
doc.text(
  `${amountInWords(netTotal)} Only`,
  7,
  footerStartY + 30
);

/* ===== QR + SIGNATURE ===== */
const qrY = footerStartY + 45;
  /* ================= ZATCA QR ================= */
  const qrBase64 = generateFatooraQR(
    company.name,
    company.tin,
    new Date(watch("invdate")).toISOString(),
    netTotal.toFixed(2),
    taxTotal.toFixed(2)
  );

  const qrImage = await QRCode.toDataURL(qrBase64);
doc.addImage(qrImage, "PNG", 10, qrY, 22, 22);

doc.setFont("helvetica", "bold");
doc.text(`For ${company.name || ""}`, 150, qrY + 14);


  /* ================= SAVE ================= */
  doc.save(`Invoice_${watch("entrynumber")}.pdf`);
};








// const buildPrintableContent = async () => {
//   const form = document.getElementById("invoice-content");
//   if (!form) return "";

//   /* ================= COMPANY ================= */
//   const company = companyInfolist?.[0] || {};
//   const companyName = company.name || "Company Name";
//   const companyAddress1 = company.address1 || "";
//   const companyAddress2 = company.address2 || "";
//   const companyAddress3 = company.address3 || "";
//   const companyPhone = company.phone || "";
//   const companyVAT = company.tin || "";

//   /* ================= CUSTOMER ================= */
//   const supplierGuid = watch("customer");
//   const supplierObj = customerList.find(c => c.guid === supplierGuid) || {};

//   const supplierName = supplierObj.name || "";
//   const supplierAddress1 = supplierObj.address1 || "";
//   const supplierMobile = supplierObj.mobile || "";
//   const supplierVAT = supplierObj.gstNo || "";

//   /* ================= INVOICE ================= */
//   const entryNumber = watch("entrynumber") || "";
//   const date = new Date(watch("invdate")).toLocaleDateString("en-GB");

//   const invDateValue = watch("invdate") || new Date().toISOString();
//   const invoiceDate = new Date(invDateValue).toISOString();

//   const paymentTypeLabel =
//     paymentType?.find(p => p.value === watch("paymentType"))?.label || "";

//   /* ================= ITEMS (DOM → PDF SAFE) ================= */
//   const tableRows = Array.from(form.querySelectorAll("tbody tr")).map(row => {
//     const unitText =
//       row.querySelector('td[data-label="Unit"] .react-select__single-value')
//         ?.textContent || "";

//     return {
//       description: row.querySelector('td[data-label="Description"]')?.innerText || "",
//       code: row.querySelector('td[data-label="Item Code"] input')?.value || "",
//       qty: Number(row.querySelector('td[data-label="Quantity"] input')?.value || 0),
//       unit: unitText,
//       rate: Number(row.querySelector('td[data-label="Price"] input')?.value || 0),
//       tax: Number(row.querySelector('td[data-label="Tax Amount"] input')?.value || 0),
//       total: Number(row.querySelector('td[data-label="Gross"] input')?.value || 0),
//       netTotal: Number(row.querySelector('td[data-label="Net Amount"] input')?.value || 0),
//     };
//   });

//   /* ================= TOTALS ================= */
//   const taxTotalPrint = Number(totalTax) || 0;
//   const discountPrint = Number(totalDiscount) || 0;
//   const netTotalPrint = Number(totalNet) || 0;
//   const additionPrint = Number(watch("addition")) || 0;
//   const roundPrint = Number(watch("round")) || 0;

//   /* ================= QR ================= */
//   const fatooraQRData = generateFatooraQR(
//     companyName,
//     companyVAT,
//     invoiceDate,
//     netTotalPrint.toFixed(2),
//     taxTotalPrint.toFixed(2)
//   );
//   const qrCodeUrl = await QRCode.toDataURL(fatooraQRData);

//   /* ================= BODY HTML ONLY ================= */
//   const printableContent = `
// <style>
// @page { size: A4; margin: 10mm; }
// body { font-family: Arial, sans-serif; font-size: 11px; color: #000; }
// table { width: 100%; border-collapse: collapse; }
// th, td { border: 1px solid #000; padding: 4px; }
// .center { text-align: center; }
// .left { text-align: left; }
// .right { text-align: right; }
// .bold { font-weight: bold; }
// .small { font-size: 10px; }
// .items tbody td { border-top: none; border-bottom: none; }
// .items tbody tr:last-child td { border-bottom: 1px solid #000; }
// .footer { border: 1px solid #000; margin-top: 6px; }
// .footer td { border: none; }
// </style>

// <div style="width:210mm; padding:10mm; background:#fff;">

// <!-- HEADER -->
// <div class="center">
//   <h2>${companyName}</h2>
//   <p>${companyAddress1}, ${companyAddress2}, ${companyAddress3}</p>
//   <p>Phone: ${companyPhone}</p>
//   <p><b>VAT:</b> ${companyVAT}</p>
//   <h3>TAX INVOICE | الفاتورة الضريبية</h3>
// </div>

// <!-- INFO -->
// <table>
//   <tr>
//     <td><b>Invoice No</b></td><td>${entryNumber}</td>
//     <td><b>Date</b></td><td>${date}</td>
//   </tr>
//   <tr>
//     <td><b>Payment</b></td><td>${paymentTypeLabel}</td>
//     <td></td><td></td>
//   </tr>
// </table>

// <!-- CUSTOMER -->
// <table style="margin-top:4px;">
//   <tr><th colspan="4" class="center">CUSTOMER DETAILS</th></tr>
//   <tr><td>Name</td><td>${supplierName}</td><td>Contact</td><td>${supplierMobile}</td></tr>
//   <tr><td>VAT</td><td>${supplierVAT}</td><td></td><td></td></tr>
//   <tr><td>Address</td><td colspan="3">${supplierAddress1}</td></tr>
// </table>

// <!-- ITEMS -->
// <table class="items" style="margin-top:6px;">
// <thead>
// <tr>
//   <th>#</th><th>Code</th><th>Description</th><th>Qty</th>
//   <th>Unit</th><th>Rate</th><th>Tax</th><th>Total</th>
// </tr>
// </thead>
// <tbody>
// ${tableRows.map((r, i) => `
// <tr>
//   <td>${i + 1}</td>
//   <td>${r.code}</td>
//   <td class="left">${r.description}</td>
//   <td>${r.qty}</td>
//   <td>${r.unit}</td>
//   <td>${r.rate.toFixed(2)}</td>
//   <td>${r.tax.toFixed(2)}</td>
//   <td>${r.netTotal.toFixed(2)}</td>
// </tr>
// `).join("")}
// </tbody>
// </table>

// <!-- TOTALS -->
// <table style="margin-top:6px;">
// <tr><td>Sub Total</td><td class="right">${(netTotalPrint - taxTotalPrint).toFixed(2)}</td></tr>
// <tr><td>VAT</td><td class="right">${taxTotalPrint.toFixed(2)}</td></tr>
// <tr><td>Discount</td><td class="right">${discountPrint.toFixed(2)}</td></tr>
// <tr><td>Addition</td><td class="right">${additionPrint.toFixed(2)}</td></tr>
// <tr><td>Round Off</td><td class="right">${roundPrint.toFixed(2)}</td></tr>
// <tr class="bold"><td>NET TOTAL</td><td class="right">${netTotalPrint.toFixed(2)}</td></tr>
// </table>

// <!-- FOOTER -->
// <table class="footer">
// <tr>
//   <td><img src="${qrCodeUrl}" width="90"/></td>
//   <td class="right bold">For ${companyName}</td>
// </tr>
// </table>

// </div>
// `;

//   return printableContent;
// };

// const pdfFunction = async () => {
//   const printableContent = await buildPrintableContent();
//   if (!printableContent) {
//     console.error("Printable content empty");
//     return;
//   }

//   const container = document.createElement("div");
//   container.id = "pdf-root";
//   container.style.position = "fixed";
//   container.style.left = "0";
//   container.style.top = "0";
//   container.style.width = "210mm";
//   container.style.background = "#fff";
//   container.style.zIndex = "99999";

//   container.innerHTML = printableContent;
//   document.body.appendChild(container);

//   // wait for layout + images
//   await new Promise(r => setTimeout(r, 800));

//   const options = {
//     margin: 10,
//     filename: `Invoice_${watch("entrynumber")}.pdf`,
//     image: { type: "jpeg", quality: 0.98 },
//     html2canvas: {
//       scale: 2,
//       useCORS: true,
//       backgroundColor: "#ffffff",
//       logging: false,
//     },
//     jsPDF: {
//       unit: "mm",
//       format: "a4",
//       orientation: "portrait",
//     },
//   };

//   try {
//     const worker = html2pdf()
//       .set(options)
//       .from(container);

//     // 🔥 IMPORTANT PART
//     await worker.toPdf().get("pdf").then(pdf => {
//       pdf.save(options.filename);
//     });
//   } catch (err) {
//     console.error("PDF generation failed:", err);
//   } finally {
//     document.body.removeChild(container);
//   }
// };




// small helper to escape html text (prevents accidental tags)
function escapeHtml(text) {
  if (text === null || text === undefined) return "";
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}


// const handlePrint = () => {
//   const printA4 = document.getElementById("printA4").checked;
//   const printThermal = document.getElementById("printThermal").checked;

//   if (printA4) {
//     printA4Function(); // Calls the A4 print function
//   } else if (printThermal) {
//     thermalPrintFunction(); // Calls the 3-inch thermal print function
//   } else {
//     alert("Please select a print type.");
//   }
  
// };
const handlePrint = (type) => {
  if (type === "A4") {
    printA4Function(); // Calls the A4 print function
  } else if (type === "Thermal") {
    thermalPrintFunction(); // Calls the 3-inch thermal print function
  } else {
    alert("Invalid selection.");
  }
};

  return (
    <div>
      <div
        className="modal fade show si-modal"
        style={{ display: "block" }}
        tabIndex="-1"
      >
        <div className="modal-dialog si-dialog">
          <div className="modal-content si-content">
            <div className="si-shell">
              <form
                id="invoice-content"
                className="si-form"
                onSubmit={handleSubmit(handleFormSubmit)}
              >
                {/* ---------- top bar ---------- */}
                <div className="si-topbar">
                  <button
                    type="button"
                    className="si-back"
                    onClick={handleClose}
                    aria-label="Close"
                  >
                    <ArrowLeft />
                  </button>
                  <div className="si-titles">
                    <h4>Sales Invoice</h4>
                    <p>
                      {mode === "edit"
                        ? "Edit an existing sales invoice"
                        : "Create a new sales invoice"}
                    </p>
                  </div>
                  <button type="button" className="si-help" aria-label="Help">
                    <HelpCircle />
                  </button>
                </div>

                {/* ---------- scrollable body ---------- */}
                <div className="si-body">
                  {/* ---------- invoice details ---------- */}
                  <div className="si-card si-card--details">
                    <div className="row">
                      {/* ---- row 1 : Entry No / Date / Reference Type / Reference No ---- */}
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6">
                        <div className="si-field si-field--disabled">
                          <span className="si-field__icon">
                            <Hash />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">
                              Entry No.<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("entrynumber")}
                              required
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Calendar />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">
                              Date<span className="text-danger">*</span>
                            </label>
                            <Controller
                              control={control}
                              name="invdate"
                              render={({ field: { onChange, value } }) => (
                                <DatePicker
                                  className="datetimepicker"
                                  value={value ? dayjs(value) : dayjs()}
                                  format="DD-MM-YYYY"
                                  onChange={(date) => {
                                    onChange(
                                      date ? date.format("YYYY-MM-DD") : null
                                    );
                                    setmindate(date);
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6 si-col--wide">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <CreditCard />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">
                              Payment Type<span className="text-danger">*</span>
                            </label>
                            <Controller
                              control={control}
                              name={`paymentType`}
                              render={({ field: { onChange, value } }) => (
                                <Select
                                  classNamePrefix="react-select"
                                  options={paymentType}
                                  value={paymentType?.find(
                                    (paymentType) => paymentType?.value === value
                                  )}
                                  onChange={(selectedOption) =>
                                    onChange(selectedOption.value)
                                  }
                                  menuPortalTarget={menuPortalTarget}
                                  menuPosition="fixed"
                                  styles={siSelectStyles}
                                  required
                                />
                              )}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Calendar />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">
                              Delivery Date
                              <span className="text-danger">*</span>
                            </label>
                            <Controller
                              control={control}
                              name="deliveryDate"
                              render={({ field: { onChange, value } }) => (
                                <DatePicker
                                  className="datetimepicker"
                                  minDate={mindate}
                                  value={value ? dayjs(value) : dayjs()}
                                  format="DD-MM-YYYY"
                                  onChange={(date) =>
                                    onChange(
                                      date ? date.format("YYYY-MM-DD") : null
                                    )
                                  }
                                />
                              )}
                            />
                            {errors.deliveryDate && (
                              <span className="si-err">
                                {errors.deliveryDate.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6 si-col--narrow">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Link2 />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">
                              Refer Type
                              <span className="text-danger">*</span>
                            </label>
                            <Controller
                              control={control}
                              name={`referencetype`}
                              render={({ field: { onChange, value } }) => (
                                <Select
                                  classNamePrefix="react-select"
                                  options={referencetype}
                                  value={referencetype?.find(
                                    (reference) => reference?.value === value
                                  )}
                                  onChange={(selectedOption) =>
                                    onChange(selectedOption.value)
                                  }
                                  menuPortalTarget={menuPortalTarget}
                                  menuPosition="fixed"
                                  styles={siSelectStyles}
                                  required
                                />
                              )}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Hash />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">
                              Reference No.
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter reference no"
                              {...register("refNo")}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Home />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">
                              Ware House<span className="text-danger">*</span>
                            </label>
                            <Controller
                              name="location"
                              control={control}
                              render={({ field }) => (
                                <Select
                                  classNamePrefix="react-select"
                                  options={formattedWarehouses}
                                  required
                                  placeholder="Select Warehouse"
                                  value={getSelectedWarehouseOption(field.value)}
                                  onChange={(option) =>
                                    field.onChange(option.value)
                                  }
                                  menuPortalTarget={menuPortalTarget}
                                  menuPosition="fixed"
                                  styles={siSelectStyles}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <UserCheck />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Salesman</label>
                            <Controller
                              control={control}
                              name="salesman"
                              render={({ field: { onChange, value } }) => (
                                <Select
                                  classNamePrefix="react-select"
                                  options={salesmanOptions}
                                  placeholder="Select salesman"
                                  isClearable
                                  value={
                                    salesmanOptions?.find(
                                      (o) => o.value === value
                                    ) ?? null
                                  }
                                  onChange={(opt) =>
                                    onChange(opt ? opt.value : null)
                                  }
                                  menuPortalTarget={menuPortalTarget}
                                  menuPosition="fixed"
                                  styles={siSelectStyles}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6 si-col--wide">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <User />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">
                              Customer<span className="text-danger">*</span>
                            </label>
                            <Controller
                              control={control}
                              name={`customer`}
                              render={({ field: { onChange, value } }) => (
                                <Select
                                  classNamePrefix="react-select"
                                  options={customerData}
                                  value={customerData?.find(
                                    (customer) => customer?.value === value
                                  )}
                                  onChange={(selectedOption) => {
                                    onChange(selectedOption.value);
                                    handlecustomerDetailFetch(selectedOption);
                                  }}
                                  menuPortalTarget={menuPortalTarget}
                                  menuPosition="fixed"
                                  styles={siSelectStyles}
                                  required
                                />
                              )}
                            />
                          </div>
                          <Link
                            to="#"
                            className="si-field__add"
                            onClick={() => {
                              setModalOpen(true);
                            }}
                          >
                            <Plus />
                          </Link>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <User />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">
                              Contact Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter contact name"
                              {...register("customerName")}
                            />
                            {errors.customerName && (
                              <span className="si-err">
                                {errors.customerName.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6 si-col--narrow">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Phone />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">
                              Cont Number
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter contact number"
                              {...register("customerContactno")}
                            />
                            {errors.customerContactno && (
                              <span className="si-err">
                                {errors.customerContactno.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-6">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <MessageSquare />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Remarks</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter remarks"
                              {...register("terms")}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ---------- invoice items ---------- */}
                  <div className="si-card si-card--items">
                    <div className="si-card-head">
                      <span className="si-head-icon">
                        <Box />
                      </span>
                      <h5>Invoice Items</h5>
                      <div className="si-head-actions">
                        <span className="si-col-toggle-label">
                          Optional columns
                        </span>
                        {OPTIONAL_COLS.map((col) => (
                          <button
                            key={col.key}
                            type="button"
                            className={`si-chip${
                              optionalCols[col.key] ? " si-chip--on" : ""
                            }`}
                            aria-pressed={optionalCols[col.key]}
                            onClick={() => toggleCol(col.key)}
                          >
                            {optionalCols[col.key] ? <Check /> : <Plus />}
                            {col.label}
                          </button>
                        ))}
                      </div>
                    </div>

                    <div className="si-table-wrap">
                      <table
                        className="table si-table"
                        style={{ minWidth: `${tableMinWidth}px` }}
                      >
                        <thead>
                          <tr>
                            <th>#</th>
                            <th className="si-th-barcode">Barcode</th>
                            <th className="si-th-name">
                              Description
                              <span className="text-danger">*</span>
                            </th>
                            {/* <th>HSN Code</th> */}
                            <th className="si-th-unit">Unit</th>
                            <th className={`si-th-batch ${colClass("batch")}`}>
                              Batch
                            </th>
                            <th className={`si-th-date ${colClass("expiry")}`}>
                              Exp Date
                            </th>
                            <th className="si-th-qty">
                              Qty<span className="text-danger">*</span>
                            </th>
                            <th className="si-th-num">
                              Price <span className="text-danger">*</span>
                            </th>
                            <th className={`si-th-num ${colClass("mrp")}`}>
                              MRP
                            </th>
                            <th className={`si-th-qty ${colClass("foc")}`}>
                              FOC
                            </th>
                            <th className="si-th-num">Gross</th>
                            <th className="si-th-disc">Disc %</th>
                            <th className="si-th-num">Disc Amt</th>
                            {branchsettings?.disableTaxInSale == false && (
                              <th className="si-th-tax">Tax %</th>
                            )}
                            {branchsettings?.disableTaxInSale == false && (
                              <th className="si-th-num">Tax Amt</th>
                            )}
                            <th className="si-th-num">Net Amt</th>
                            <th className="si-th-act">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {fields.map((field, index) => {
                            // keep react-hook-form's own onBlur alive while
                            // adding the barcode lookup on top of it
                            const barcodeField = register(
                              `items[${index}].code`
                            );
                            return (
                              <tr key={field.id}>
                                <td className="si-row-no">{index + 1}</td>
                                <td data-label="Barcode">
                                  <input
                                    type="text"
                                    className="form-control si-barcode-input"
                                    placeholder="Scan / enter"
                                    autoComplete="off"
                                    {...barcodeField}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        // a scanner ends its input with Enter -
                                        // don't let that submit the invoice
                                        e.preventDefault();
                                        handleBarcodeEntry(
                                          e.target.value,
                                          index
                                        );
                                      }
                                    }}
                                    onBlur={(e) => {
                                      barcodeField.onBlur(e);
                                      handleBarcodeEntry(e.target.value, index);
                                    }}
                                  />
                                </td>
                                <td data-label="Description">
                                  <div className="si-desc-cell">
                                  <Controller
                                    control={control}
                                    name={`items[${index}].product`}
                                    rules={{
                                      validate: (value) => {
                                        if (isPlaceholderRow(index)) return true;
                                        if (!value) return "Product is required";
                                        const selectedProducts = watch(
                                          "items"
                                        )?.map((item) => item.product); // Get all selected products
                                        const isDuplicate =
                                          selectedProducts?.filter(
                                            (product) => product === value
                                          )?.length > 1;
                                        return (
                                          !isDuplicate ||
                                          "Duplicate product selected!"
                                        );
                                      },
                                    }}
                                    render={({ field: { onChange, value } }) => (
                                      <Select
                                        classNamePrefix="react-select"
                                        options={products}
                                        filterOption={productFilterOption}
                                        placeholder="Item name or barcode"
                                        value={products?.find(
                                          (option) => option.value === value
                                        )}
                                        onChange={(selectedOption) => {
                                          onChange(selectedOption.value);
                                          handleEachProductfetch(
                                            selectedOption,
                                            index
                                          );
                                        }}
                                        menuPortalTarget={menuPortalTarget}
                                          menuPosition="fixed"
                                          styles={siSelectStyles}
                                      />
                                    )}
                                  />
                                  <button
                                    type="button"
                                    className={`si-note-btn${
                                      watch(`items[${index}].notes`)
                                        ? " si-note-btn--set"
                                        : ""
                                    }`}
                                    title="Item notes"
                                    aria-label="Item notes"
                                    onClick={() => openNotes(index)}
                                  >
                                    <FileText />
                                  </button>
                                  </div>
                                  {errors.items &&
                                    errors.items[index]?.product && (
                                      <span className="si-err">
                                        {errors.items[index].product.message}
                                      </span>
                                    )}
                                </td>
                                {/* <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(`items[${index}].hsnCode`)}
                                    disabled
                                  />
                                </td> */}
                                <td data-label="Unit" className="si-th-unit">
                                  <Controller
                                    control={control}
                                    name={`items[${index}].unit`}
                                    render={({ field: { onChange, value } }) => (
                                      <Select
                                        classNamePrefix="react-select"
                                        options={unitData}
                                        value={unitData?.find(
                                          (option) => option.value === value
                                        )}
                                        onChange={(selectedOption) => {
                                          onChange(selectedOption.value);
                                        }}
                                        isDisabled={true}
                                      />
                                    )}
                                  />
                                </td>

                                <td className={colClass("batch")}>
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(`items[${index}].batch`)}
                                  />
                                </td>
                                <td className={colClass("expiry")}>
                                  <Controller
                                    control={control}
                                    name={`items[${index}].expiry`}
                                    render={({ field: { onChange, value } }) => (
                                      <DatePicker
                                        className="datetimepicker"
                                        placeholder={
                                          value ? dayjs(value) : dayjs()
                                        }
                                        value={value ? dayjs(value) : dayjs()}
                                        format="DD-MM-YY"
                                        onChange={(date) => onChange(date)}
                                      />
                                    )}
                                  />
                                </td>
                                <td data-label="Quantity" className="si-cell-num">
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(`items[${index}].quantity`, {
                                      validate: (value) => {
                                        if (isPlaceholderRow(index)) return true;
                                        if (value === "" || value == null)
                                          return "Quantity is required";
                                        return (
                                          (!isNaN(value) && value > 0) ||
                                          "Quantity must be a positive number"
                                        );
                                      },
                                    })}
                                  />
                                  {errors.items &&
                                    errors.items[index]?.quantity && (
                                      <span className="si-err">
                                        {errors.items[index].quantity.message}
                                      </span>
                                    )}
                                </td>
                                <td data-label="Price" className="si-cell-num">
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(`items[${index}].price`, {
                                      validate: (value) => {
                                        if (isPlaceholderRow(index)) return true;
                                        if (value === "" || value == null)
                                          return "Price is required";
                                        return (
                                          (!isNaN(value) && value > 0) ||
                                          "Price must be a positive number"
                                        );
                                      },
                                    })}
                                  />
                                  {errors.items && errors.items[index]?.price && (
                                    <span className="si-err">
                                      {errors.items[index].price.message}
                                    </span>
                                  )}
                                </td>
                                <td className={`si-cell-num ${colClass("mrp")}`}>
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(`items[${index}].mrp`, {
                                      validate: (value) =>
                                        (!isNaN(value) && value >= 0) ||
                                        "MRP must be zero or more",
                                    })}
                                  />
                                  {errors.items && errors.items[index]?.mrp && (
                                    <span className="si-err">
                                      {errors.items[index].mrp.message}
                                    </span>
                                  )}
                                </td>
                                <td className={`si-cell-num ${colClass("foc")}`}>
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(`items[${index}].foc`, {
                                      validate: (value) =>
                                        (!isNaN(value) && value >= 0) ||
                                        "FOC must be zero or more",
                                    })}
                                  />
                                  {errors.items && errors.items[index]?.foc && (
                                    <span className="si-err">
                                      {errors.items[index].foc.message}
                                    </span>
                                  )}
                                </td>
                                <td data-label="Gross" className="si-cell-num">
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(`items[${index}].gross`)}
                                    disabled
                                  />
                                </td>
                                {/* typed in directly - no dropdown, zero by default */}
                                <td
                                  data-label="Discount Percentage"
                                  className="si-cell-num"
                                >
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(
                                      `items[${index}].discountPercentage`,
                                      {
                                        validate: (value) =>
                                          value === "" ||
                                          value === null ||
                                          value === undefined ||
                                          (!isNaN(value) &&
                                            Number(value) >= 0 &&
                                            Number(value) <= 100) ||
                                          "Discount % must be between 0 and 100",
                                      }
                                    )}
                                  />
                                  {errors.items &&
                                    errors.items[index]?.discountPercentage && (
                                      <span className="si-err">
                                        {
                                          errors.items[index].discountPercentage
                                            .message
                                        }
                                      </span>
                                    )}
                                </td>
                                <td data-label="Discount Amount" className="si-cell-num">
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(
                                      `items[${index}].discountAmount`
                                    )}
                                    disabled
                                  />
                                </td>
                                {branchsettings?.disableTaxInSale == false && (
                                  <td data-label="Tax %">
                                    <Controller
                                      control={control}
                                      name={`items[${index}].taxPercentage`}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <Select
                                          classNamePrefix="react-select"
                                          options={taxData}
                                          placeholder="select"
                                          value={taxData?.find(
                                            (option) => option.guid === value
                                          )}
                                          onChange={(selectedOption) => {
                                            // this field holds the tax GUID -
                                            // the row calculation, the submit
                                            // payload and the edit loader all
                                            // resolve it with .guid, so store
                                            // the guid and not the percentage
                                            onChange(
                                              selectedOption
                                                ? selectedOption.guid
                                                : null
                                            );
                                          }}
                                          menuPortalTarget={menuPortalTarget}
                                          menuPosition="fixed"
                                          styles={siSelectStyles}
                                        />
                                      )}
                                    />
                                  </td>
                                )}
                                {branchsettings?.disableTaxInSale == false && (
                                  <td data-label="Tax Amount" className="si-cell-num">
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].taxAmount`)}
                                      disabled
                                    />
                                  </td>
                                )}
                                <td data-label="Net Amount" className="si-cell-num">
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(`items[${index}].netTotal`)}
                                    disabled
                                  />
                                </td>
                                <td className="si-row-del">
                                  <Link
                                    to="#"
                                    className="si-del-btn confirm-text"
                                    onClick={() => handleRemove(index)}
                                  >
                                    <Trash2 />
                                  </Link>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* ---------- invoice summary ---------- */}
                  <div className="si-card si-card--summary">
                    <div className="si-card-head">
                      <span className="si-head-icon">
                        <FileText />
                      </span>
                      <h5>Invoice Summary</h5>
                    </div>

                    <div className="si-summary">
                      <div className="si-sum-item">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Plus />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Addition</label>
                            <input
                              type="number"
                              step="any"
                              min={0}
                              className="form-control"
                              defaultValue={0}
                              {...register(`addition`)}
                            />
                            {errors.addition && (
                              <span className="si-err">
                                {errors.addition.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="si-sum-item">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Minus />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Discount</label>
                            <input
                              type="number"
                              step="any"
                              min={0}
                              className="form-control"
                              defaultValue={0}
                              {...register(`subtraction`, {
                                validate: (value) => {
                                  const discount = safeNumber(value);
                                  const totalNetAfterDiscount =
                                    totalNet - discount;
                                  if (discount < 0) {
                                    return "Discount value should not be negative.";
                                  } else if (totalNetAfterDiscount < 0) {
                                    return "Please enter a discount value that does not exceed the Net Total.";
                                  }
                                  return true;
                                },
                              })}
                            />
                            {errors.subtraction && (
                              <span className="si-err">
                                {errors.subtraction.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="si-sum-item">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Shuffle />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Round Off</label>
                            <input
                              type="number"
                              step="any"
                              min={0}
                              className="form-control"
                              defaultValue={0}
                              {...register(`round`, {
                                validate: (value) => {
                                  const round = safeNumber(value);
                                  const totalNetAfterRound = totalNet - round;
                                  return (
                                    totalNetAfterRound >= 0 ||
                                    "Please enter a round-off value that does not exceed Net Total."
                                  );
                                },
                              })}
                            />
                            {errors.round && (
                              <span className="si-err">
                                {errors.round.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <span className="si-sum-sep" />

                      <div className="si-sum-item si-sum-item--value">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Database />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Gross</label>
                            <span
                              className="si-value"
                              title={totalGross?.toFixed(decimalpoints)}
                            >
                              {totalGross?.toFixed(decimalpoints)}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="si-sum-item si-sum-item--value">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <Percent />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Discount</label>
                            <span
                              className="si-value"
                              title={totalDiscount?.toFixed(decimalpoints)}
                            >
                              {totalDiscount?.toFixed(decimalpoints)}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="si-sum-item si-sum-item--value">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <FileText />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Tax Total</label>
                            <span
                              className="si-value"
                              title={totalTax?.toFixed(decimalpoints)}
                            >
                              {totalTax?.toFixed(decimalpoints)}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="si-sum-item si-sum-item--value si-sum-total">
                        <div className="si-field">
                          <span className="si-field__icon">
                            <FileText />
                          </span>
                          <div className="si-field__box">
                            <label className="si-field__label">Net Total</label>
                            <span
                              className="si-value"
                              title={totalNet?.toFixed(decimalpoints)}
                            >
                              {totalNet?.toFixed(decimalpoints)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ---------- footer ---------- */}
                <div className="si-footer">
                  <button
                    type="button"
                    className="si-btn"
                    onClick={() => resetmodal()}
                  >
                    <RotateCcw />
                    Reset
                  </button>

                  <button
                    type="button"
                    className="si-icon-btn si-icon-btn--lg"
                    title={`Print settings - ${
                      printPrefs.format === "Thermal" ? "3-inch" : "A4"
                    }${
                      printPrefs.useSystemDefault
                        ? " on the system default printer"
                        : printPrefs.printerName
                        ? ` on ${printPrefs.printerName}`
                        : ""
                    }`}
                    aria-label="Print settings"
                    onClick={openPrintPrefs}
                  >
                    <Settings />
                  </button>

                  <button
                    type="button"
                    className="si-btn"
                    onClick={pdfFunction}
                  >
                    <FileText />
                    PDF
                  </button>

                  <div className="si-footer-pay si-footer-pay--right">
                  <div className="si-sum-item si-sum-item--pay">
                    <div className="si-field">
                      <span className="si-field__icon">
                        <CreditCard />
                      </span>
                      <div className="si-field__box">
                        <label className="si-field__label">Paid</label>
                        <input
                          type="text"
                          className="form-control"
                          {...register("paid")}
                          defaultValue={0}
                        />
                        {errors.paid && (
                          <span className="si-err">
                            {errors.paid.message}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="si-sum-item si-sum-item--pay">
                    <div className="si-field si-field--disabled">
                      <span className="si-field__icon">
                        <Repeat />
                      </span>
                      <div className="si-field__box">
                        <label className="si-field__label">Change</label>
                        <input
                          type="text"
                          className="form-control"
                          {...register("change")}
                          defaultValue={0}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  </div>
                  <div className="si-footer-right">
                    <button
                      className="si-btn si-btn--accent"
                      type="submit"
                      onClick={() => setPrintOnSave(true)}
                    >
                      <Printer />
                      SAVE &amp; PRINT
                    </button>

                    <button
                      className="si-btn si-btn--primary"
                      type="submit"
                      onClick={() => setPrintOnSave(false)}
                    >
                      <Check />
                      SAVE
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {notesRow !== null && (
        <div className="si-modal si-pop-layer">
          <div className="si-pop-scrim" onClick={() => setNotesRow(null)} />
          <div className="si-pop si-pop--center" role="dialog">
            <div className="si-pop__head">
              <FileText />
              <h6>Item notes</h6>
            </div>
            <div className="si-pop__body">
              <textarea
                className="si-pop__area"
                rows={4}
                autoFocus
                placeholder="Notes for this item"
                value={draftNote}
                onChange={(e) => setDraftNote(e.target.value)}
              />
            </div>
            <div className="si-pop__foot">
              <button
                type="button"
                className="si-btn si-btn--sm"
                onClick={() => setNotesRow(null)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="si-btn si-btn--sm si-btn--primary"
                onClick={applyNotes}
              >
                Save note
              </button>
            </div>
          </div>
        </div>
      )}

      {printPrefsOpen && (
        <div className="si-modal si-pop-layer">
          <div className="si-pop-scrim" onClick={() => setPrintPrefsOpen(false)} />
          <div className="si-pop si-pop--center" role="dialog">
            <div className="si-pop__head">
              <Printer />
              <h6>Print settings</h6>
            </div>
            <div className="si-pop__body">
              <label className="si-pop__label">Default format</label>
              {[
                { value: "A4", label: "A4" },
                { value: "Thermal", label: "3-inch thermal" },
              ].map((opt) => (
                <label
                  className={`si-pop__row si-pop__row--format${
                    draftPrint.format === opt.value ? " si-pop__row--on" : ""
                  }`}
                  key={opt.value}
                >
                  <input
                    type="radio"
                    name="si-print-format"
                    checked={draftPrint.format === opt.value}
                    onChange={() =>
                      setDraftPrint((prev) => ({ ...prev, format: opt.value }))
                    }
                  />
                  <span>{opt.label}</span>
                </label>
              ))}

              <label className="si-pop__label">Printer</label>
              <label className="si-pop__row">
                <input
                  type="checkbox"
                  checked={!!draftPrint.useSystemDefault}
                  onChange={(e) =>
                    setDraftPrint((prev) => ({
                      ...prev,
                      useSystemDefault: e.target.checked,
                    }))
                  }
                />
                <span>Use the system default printer</span>
              </label>

              <label className="si-pop__label">Printer name</label>
              <input
                type="text"
                className="si-pop__input"
                placeholder="e.g. Counter-1 A4"
                disabled={!!draftPrint.useSystemDefault}
                value={draftPrint.printerName}
                onChange={(e) =>
                  setDraftPrint((prev) => ({
                    ...prev,
                    printerName: e.target.value,
                  }))
                }
              />
              <p className="si-pop__hint">
                Saved for <strong>this billing system only</strong>, so a
                counter that prints A4 and one that prints 3-inch each keep
                their own default. Print and SAVE &amp; PRINT then use it
                without asking.
                <br />
                <br />
                The printer name is a label for the operator - browsers cannot
                pick the physical printer, so the OS print dialog still does
                that final step.
              </p>
            </div>
            <div className="si-pop__foot">
              <button
                type="button"
                className="si-btn si-btn--sm"
                onClick={() => setPrintPrefsOpen(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="si-btn si-btn--sm si-btn--primary"
                onClick={applyPrintPrefs}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}

      {modalOpen && (
        <CustomerModal
          mode="add"
          data={{}}
          handleClose={() => setModalOpen(false)}
          handleRefresh={() => {}}
        />
      )}
    </div>
  );
};
export default SalesInvoiceModal;
